import "@fontsource/merriweather/300.css";
import "@fontsource/merriweather/400.css";
import "@fontsource/merriweather/700.css";
import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/open-sans/800.css";
import { ChakraProvider as Jo, defineStyle as C, defineStyleConfig as q, createMultiStyleConfigHelpers as N, cssVar as ut, useStyleConfig as Qo, chakra as ne, Badge as er, useMultiStyleConfig as A, Box as M, Icon as ao, FormControl as tr, FormLabel as or, FormHelperText as rr, Switch as nr, Skeleton as ar, useTheme as ir, Button as lr, IconButton as sr, ButtonGroup as cr, Popover as bt, PopoverTrigger as ht, PopoverContent as gt, PopoverBody as mt, Stack as J, Flex as P, Td as dr, Tr as pr, Center as xe, VStack as E, Th as ur, TableContainer as br, keyframes as hr, usePrefersReducedMotion as gr, InputGroup as mr, InputLeftElement as io, InputLeftAddon as fr, Divider as nt, Input as yr, InputRightElement as ft, InputRightAddon as xr, Select as Sr, Tbody as vr, Thead as Cr, useBreakpointValue as ae, Checkbox as Pe, Table as wr, HStack as Fe, Tag as kr, TagLabel as $r, Accordion as _r, AccordionItem as Ir, AccordionButton as zr, AccordionPanel as Mr, Tabs as Dr, TabList as Br, Tab as Nr, TabPanels as Pr, TabPanel as Ar, useAlertStyles as Tr, Alert as Rr, AlertTitle as Er, AlertDescription as Fr, CloseButton as Wr, Spinner as Hr, Progress as Lr, useToast as Gr, NumberInput as Or, NumberInputField as Vr, NumberInputStepper as jr, NumberDecrementStepper as Ur, NumberIncrementStepper as Yr, Radio as qr, Slider as Xr, SliderTrack as Zr, SliderFilledTrack as Kr, SliderThumb as Jr, Textarea as Qr, Avatar as en, BreadcrumbItem as tn, BreadcrumbLink as lo, Menu as on, MenuItem as rn, MenuGroup as nn, MenuDivider as an, MenuList as ln, MenuButton as sn, Breadcrumb as cn, Link as We, Spacer as dn, AlertDialog as pn, AlertDialogOverlay as un, AlertDialogContent as bn, AlertDialogHeader as hn, AlertDialogCloseButton as gn, AlertDialogBody as mn, AlertDialogFooter as fn, Modal as yn, ModalOverlay as xn, ModalContent as Sn, ModalHeader as vn, ModalCloseButton as Cn, ModalBody as wn, ModalFooter as kn, Tooltip as $n, PopoverArrow as _n, PopoverCloseButton as In, PopoverHeader as zn, PopoverFooter as Mn, useDisclosure as Dn, useOutsideClick as Bn, StackDivider as so, Collapse as Nn } from "@chakra-ui/react";
import { jsx as t, jsxs as b, Fragment as j } from "react/jsx-runtime";
import { accordionAnatomy as Pn, tableAnatomy as An, tagAnatomy as Tn, tabsAnatomy as Rn, alertAnatomy as En, progressAnatomy as Fn, checkboxAnatomy as Wn, formAnatomy as Hn, formErrorAnatomy as Ln, inputAnatomy as Gn, numberInputAnatomy as On, radioAnatomy as Vn, selectAnatomy as jn, sliderAnatomy as Un, switchAnatomy as Yn, avatarAnatomy as qn, breadcrumbAnatomy as Xn, menuAnatomy as Zn, modalAnatomy as Kn, popoverAnatomy as Jn } from "@chakra-ui/anatomy";
import { defineStyle as X, defineStyleConfig as Qn, createMultiStyleConfigHelpers as co, cssVar as yt } from "@chakra-ui/styled-system";
import { cssVar as Z, getColor as Ft, orient as xt, calc as po } from "@chakra-ui/theme-tools";
import { mergeWith as ea } from "@chakra-ui/utils";
import Wt, { forwardRef as D, useRef as ue, useState as L, useEffect as U, useMemo as G, useId as ta, Fragment as oa, useCallback as uo, cloneElement as re, createContext as He, useContext as Le } from "react";
import { FontAwesomeIcon as bo } from "@fortawesome/react-fontawesome";
import { faArrowDown as ra, faArrowLeft as na, faArrowRight as aa, faArrowUp as ia, faAtom as la, faBell as sa, faCalendar as ca, faCheck as da, faChevronDown as pa, faChevronLeft as ua, faChevronRight as ba, faChevronUp as ha, faCircle as ga, faCircle0 as ma, faCircle1 as fa, faCircle2 as ya, faCircle3 as xa, faCircle4 as Sa, faCircle5 as va, faCircle6 as Ca, faCircle7 as wa, faCircle8 as ka, faCircle9 as $a, faCircleCheck as _a, faCircleDot as Ia, faCircleInfo as za, faCircleXmark as Ma, faCloudArrowUp as Da, faComment as Ba, faCreditCard as Na, faCreditCardFront as Pa, faDollarSign as Aa, faEye as Ta, faFilter as Ra, faMagnifyingGlass as Ea, faMinus as Fa, faPlus as Wa, faTriangleExclamation as Ha, faXmark as La } from "@fortawesome/pro-solid-svg-icons";
import { faArrowDown as Ga, faArrowLeft as Oa, faArrowRight as Va, faArrowUp as ja, faAtom as Ua, faBell as Ya, faCalendar as qa, faCheck as Xa, faChevronDown as Za, faChevronLeft as Ka, faChevronRight as Ja, faChevronUp as Qa, faCircle as ei, faCircle0 as ti, faCircle1 as oi, faCircle2 as ri, faCircle3 as ni, faCircle4 as ai, faCircle5 as ii, faCircle6 as li, faCircle7 as si, faCircle8 as ci, faCircle9 as di, faCircleCheck as pi, faCircleDot as ui, faCircleInfo as bi, faCircleXmark as hi, faCloudArrowUp as gi, faComment as mi, faCreditCard as fi, faCreditCardFront as yi, faDollarSign as xi, faEye as Si, faFilter as vi, faMagnifyingGlass as Ci, faMinus as wi, faPlus as ki, faTriangleExclamation as $i, faXmark as ho } from "@fortawesome/pro-light-svg-icons";
import { flexRender as De, useReactTable as _i, getCoreRowModel as Ii, getExpandedRowModel as zi, getSortedRowModel as Mi } from "@tanstack/react-table";
import { AnimatePresence as Di, LazyMotion as Bi, domMax as Ni, m as Ze, motion as Pi } from "framer-motion";
import { useDrop as Ai, useDrag as Ti, DndProvider as Ri } from "react-dnd";
import { HTML5Backend as Ei } from "react-dnd-html5-backend";
import { useDebouncedCallback as Fi } from "use-debounce";
import Wi from "react-paginate";
import Hi from "react-datepicker";
import { NumericFormat as Li, PatternFormat as Gi } from "react-number-format";
import { useCheckboxGroup as Oi } from "@chakra-ui/checkbox";
import { useRadioGroup as Vi } from "@chakra-ui/radio";
import { useDropzone as ji } from "react-dropzone";
const Jp = ({
  children: e,
  theme: o
}) => /* @__PURE__ */ t(Jo, {
  theme: o,
  children: e
}), Ui = C({
  display: "inline-block",
  width: "100%",
  height: "auto",
  fill: "currentColor"
}), Yi = C({
  grayscale: {
    color: "gray.800"
  },
  colour: {
    ".cls-1": {
      color: "#62bb46"
    },
    ".cls-2": {
      color: "#ffd600"
    }
  }
}), qi = q({
  baseStyle: Ui,
  variants: Yi,
  defaultProps: {
    variant: "colour"
  }
}), { defineMultiStyleConfig: Xi, definePartsStyle: Zi } = N(Pn.keys), Ki = C({
  borderTopWidth: "1px",
  borderColor: "gray.200",
  _last: {
    borderBottomWidth: "1px"
  }
}), Ji = C({
  transitionProperty: "common",
  transitionDuration: "normal",
  textStyle: "subheading2",
  py: 2,
  px: 4,
  svg: {
    ml: 3,
    color: "teal.500"
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "gray.100",
    svg: {
      color: "teal.600"
    }
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed"
  },
  _expanded: {
    svg: {
      color: "teal.700"
    },
    _hover: {
      bg: "gray.100"
    }
  }
}), Qi = C({
  bg: "teal.25",
  pt: 2,
  px: 4,
  pb: 4
}), el = Zi({
  root: {},
  container: Ki,
  button: Ji,
  panel: Qi
}), tl = Xi({
  baseStyle: el
}), ol = X({
  textStyle: "bodyBoldSmall",
  px: 1,
  borderRadius: "base"
}), rl = X((e) => {
  const { colorScheme: o, theme: r } = e;
  return {
    bg: `${o}.100`,
    color: `${o}.800`
  };
}), nl = {
  subtle: rl
}, al = Qn({
  baseStyle: ol,
  variants: nl,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
}), { defineMultiStyleConfig: il, definePartsStyle: Qp } = N([
  "container",
  "header",
  "body"
]), ll = il({
  baseStyle: {
    container: {
      p: "4",
      borderWidth: "1px",
      borderRadius: "lg",
      borderColor: "gray.200",
      bg: "white"
    },
    header: {
      pb: 3
    },
    body: {}
  },
  variants: {},
  defaultProps: {}
}), sl = N(["container"]), cl = sl.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: "inline-flex",
      gap: "8px",
      "> li": {
        display: "inline-block"
      },
      "> li:not(.previous):not(.next)": {
        display: "none"
      },
      "> li.disabled > a > div": {
        opacity: 0.5,
        cursor: "not-allowed",
        boxShadow: "none"
      },
      "> li.previous, li.next": {
        fontSize: "16px"
      },
      "li:not(.previous, .next)": {
        backgroundColor: "white",
        borderRadius: "lg",
        height: "32px",
        minWidth: "32px",
        mx: 1,
        my: 0,
        px: 1,
        py: 0
      },
      "li:not(.previous, .next) > a": {
        alignItems: "center",
        color: "gray.800",
        display: "flex",
        fontSize: "md",
        fontWeight: 700,
        height: "100%",
        justifyContent: "center"
      },
      "li:not(.previous, .next).selected > a, li:not(.previous, .next):hover > a": {
        color: "white"
      },
      "li:not(.previous, .next).selected, li:not(.previous, .next):hover": {
        bg: "teal.600",
        borderColor: "teal.600"
      }
    }
  }
}), { defineMultiStyleConfig: dl, definePartsStyle: at } = N(An.keys), Ht = C({
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}), pl = at({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    textStyle: "bodyBold",
    textAlign: "left",
    whiteSpace: "pre-wrap",
    verticalAlign: "bottom"
  },
  td: {
    whiteSpace: "pre-wrap",
    textStyle: { base: "subheading2", md: "bodySmall" },
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "body",
    textAlign: "center",
    fontWeight: "medium"
  }
}), ul = dl({
  baseStyle: pl,
  variants: {
    base: at(({ theme: e }) => ({
      th: {
        borderBottom: "1px",
        borderTop: "1px",
        borderColor: "gray.200",
        backgroundColor: "gray.50",
        ...Ht
      },
      tr: {
        _first: {
          td: {
            borderTop: "1px",
            borderColor: "gray.200"
          }
        }
      },
      td: {
        borderBottom: "1px",
        borderColor: "gray.200",
        ...Ht
      },
      caption: {
        color: "gray.600"
      },
      tfoot: {
        tr: {
          "&:last-of-type": {
            th: { borderBottomWidth: 0 }
          }
        }
      }
    }))
  },
  sizes: {
    md: at({
      th: {
        px: { base: 4, md: 6 },
        py: 3
      },
      td: {
        px: { base: 4, md: 6 },
        py: { base: 2, md: 5 },
        lineHeight: "1"
      },
      caption: {
        px: "6",
        py: "2",
        fontSize: "sm"
      }
    })
  },
  defaultProps: {
    variant: "base",
    size: "md"
  }
}), { defineMultiStyleConfig: bl, definePartsStyle: hl } = co(Tn.keys), gl = X({
  px: 2,
  borderRadius: "lg",
  outline: 0,
  _focusVisible: {
    boxShadow: "outline"
  }
}), ml = X({
  textStyle: "bodyBoldSmall",
  overflow: "visible"
}), fl = X({
  height: "14px",
  width: "14px",
  minW: "14px",
  minH: "14px",
  marginLeft: 1
}), yl = hl({
  container: gl,
  label: ml,
  closeButton: fl
}), xl = X((e) => {
  const { colorScheme: o, theme: r } = e;
  return {
    container: {
      bg: `${o}.100`
    },
    label: {
      color: `${o}.800`
    }
  };
}), Sl = {
  subtle: xl
}, vl = bl({
  variants: Sl,
  baseStyle: yl,
  defaultProps: {
    variant: "subtle",
    colorScheme: "teal"
  }
}), Cl = q({
  variants: {
    h1: {
      textStyle: "h1"
    },
    h2: {
      textStyle: "h2"
    },
    h3: {
      textStyle: "h3"
    },
    h4: {
      textStyle: "h4"
    },
    subheading1: {
      textStyle: "subheading1"
    },
    subheading2: {
      textStyle: "subheading2"
    },
    body: {
      textStyle: "body"
    },
    bodyBold: {
      textStyle: "bodyBold"
    },
    bodySmall: {
      textStyle: "bodySmall"
    },
    bodyBoldSmall: {
      textStyle: "bodyBoldSmall"
    }
  },
  baseStyle: {},
  sizes: {},
  defaultProps: {}
}), { defineMultiStyleConfig: wl, definePartsStyle: St } = N(Rn.keys), kl = C((e) => {
  const { orientation: o } = e;
  return {
    display: o === "vertical" ? "flex" : "block",
    ".tabs-scrollable": {
      overflowX: "scroll",
      position: "relative"
    },
    ".tabs-scrollable::-webkit-scrollbar": {
      display: "none",
      msOverflowStyle: "none",
      scrollbarWidth: "none"
    }
  };
}), $l = C((e) => {
  const { isFitted: o } = e;
  return {
    flex: o ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}), _l = C((e) => {
  const { align: o = "start", orientation: r } = e;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[o],
    flexDirection: r === "vertical" ? "column" : "row"
  };
}), Il = C({
  p: 4
}), zl = St((e) => ({
  root: kl(e),
  tab: $l(e),
  tablist: _l(e),
  tabpanel: Il
})), Ml = {
  md: St({
    tab: {
      textStyle: "subheading1",
      py: 2,
      px: 4
    }
  })
}, Dl = St((e) => {
  const { orientation: o } = e, r = o === "vertical", n = o === "vertical" ? "borderStart" : "borderBottom", a = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [n]: "2px solid",
      borderColor: "gray.200"
    },
    tab: {
      [n]: "2px solid",
      borderColor: "gray.200",
      [a]: "-2px",
      color: "gray.600",
      _hover: {
        color: "teal.500",
        borderColor: "teal.500"
      },
      _selected: {
        color: "teal.700",
        borderColor: "teal.700"
      },
      _disabled: {
        _active: { bg: "none" }
      }
    }
  };
}), Bl = wl({
  baseStyle: zl,
  sizes: Ml,
  variants: {
    line: Dl
  },
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
}), S = {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "24px",
  "3xl": "28px",
  "4xl": "36px",
  "5xl": "48px",
  "6xl": "64px"
}, vt = {
  xs: { fontSize: S.xs },
  sm: { fontSize: S.sm },
  md: { fontSize: S.md },
  lg: { fontSize: S.lg },
  xl: { fontSize: S.xl },
  "2xl": { fontSize: S["2xl"] },
  "3xl": { fontSize: S["3xl"] },
  "4xl": { fontSize: S["4xl"] },
  "5xl": { fontSize: S["5xl"] },
  "6xl": { fontSize: S["6xl"] }
}, Nl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  iconSizes: S,
  iconSizeStyles: vt
}, Symbol.toStringTag, { value: "Module" })), { defineMultiStyleConfig: Pl, definePartsStyle: Ct } = N(En.keys), Al = Ct((e) => {
  const { colorScheme: o } = e;
  return {
    container: {
      paddingLeft: 3,
      borderStartWidth: "4px",
      borderStartColor: `${o}.500`,
      bg: `${o}.100`,
      borderRadius: "lg",
      alignItems: "start"
    },
    title: {
      textStyle: "bodyBold"
    },
    description: {
      textStyle: "body",
      display: "inline-block"
    },
    icon: {
      flexShrink: 0,
      marginEnd: 3
    }
  };
}), Tl = Ct({
  container: {
    paddingRight: { base: "52px", md: "60px" },
    py: { base: 3, md: 4 }
  },
  icon: {
    marginTop: { base: "2px", md: 0 },
    w: { base: S.xl, md: S["2xl"] },
    h: { base: S.xl, md: S["2xl"] }
  }
}), Rl = Ct({
  container: {
    paddingRight: 10,
    py: { base: 2, md: 3 },
    boxShadow: "xl"
  },
  icon: {
    marginTop: "2px",
    w: S.xl,
    h: S.xl
  }
}), El = Pl({
  baseStyle: Al,
  variants: {
    "left-accent": Tl,
    toast: Rl
  },
  defaultProps: {
    variant: "left-accent",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: Fl } = N(Fn.keys), Wl = Fl({
  sizes: {
    sm: {
      track: { h: 2 }
    },
    md: {
      track: { h: 3 }
    },
    lg: {
      track: { h: 4 }
    }
  },
  baseStyle: {
    filledTrack: {
      bg: "green.500",
      transition: "width 0.3s ease-in-out"
    },
    track: {
      bg: "gray.100",
      "&.gravity-progress__appear-full": {
        div: {
          w: "100% !important"
        }
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "normal"
  },
  variants: {
    normal: {
      filledTrack: {
        bg: "green.500"
      }
    },
    error: {
      filledTrack: {
        bg: "red.500"
      }
    }
  }
}), Hl = N(["container"]), Ll = Hl.defineMultiStyleConfig({
  baseStyle: {
    container: {
      bg: "white",
      borderRadius: "lg",
      p: { base: 4, md: "40px" }
    }
  },
  variants: {},
  defaultProps: {}
}), Gl = q({
  baseStyle: {
    color: "teal.500"
  },
  sizes: {
    sm: {
      h: "14px",
      w: "14px"
    },
    md: {
      h: "16px",
      w: "16px"
    },
    lg: {
      h: "18px",
      w: "18px"
    }
  },
  defaultProps: {
    size: "md"
  }
}), Ol = Z("skeleton-start-color"), Vl = Z("skeleton-end-color"), jl = C((e) => {
  const o = "gray.400", r = "gray.100", { startColor: n = o, endColor: a = r, theme: i } = e, l = Ft(i, n), s = Ft(i, a);
  return {
    [Ol.variable]: l,
    [Vl.variable]: s,
    opacity: 0.7,
    borderRadius: "base",
    borderColor: l,
    background: s
  };
}), Ul = q({
  baseStyle: jl
}), Yl = C((e) => {
  const o = {
    bg: "red.500",
    _hover: { bg: "red.600" },
    _active: { bg: "red.700" }
  }, r = {
    bg: "teal.500",
    _hover: { bg: "teal.600" },
    _active: { bg: "teal.700" }
  };
  return {
    color: "white",
    borderColor: "transparent",
    ...e.colorScheme === "red" ? o : r
  };
}), ql = C((e) => {
  const o = {
    color: "red.500",
    _hover: {
      color: "red.600",
      bg: "gray.100"
    },
    _active: {
      color: "red.700",
      bg: "gray.200"
    }
  }, r = {
    color: "teal.500",
    bg: "transparent",
    _hover: {
      color: "teal.600",
      bg: "gray.100"
    },
    _active: {
      color: "teal.700",
      bg: "gray.200"
    }
  };
  return {
    borderColor: "transparent",
    ...e.colorScheme === "red" ? o : r
  };
}), Xl = C((e) => {
  const o = {
    color: "red.500",
    _hover: {
      color: "red.600",
      bg: "gray.100"
    },
    _active: {
      color: "red.700",
      bg: "gray.200"
    }
  }, r = {
    color: "teal.500",
    _hover: {
      color: "teal.600",
      bg: "gray.100"
    },
    _active: {
      color: "teal.700",
      bg: "gray.200"
    }
  };
  return {
    bg: "white",
    borderColor: "gray.200",
    ...e.colorScheme === "red" ? o : r,
    ".chakra-button__group[data-attached] > &:not(:last-of-type)": {
      marginEnd: "-1px"
    }
  };
}), Zl = C((e) => {
  const o = {
    color: "red.500",
    borderColor: "red.500",
    _hover: {
      color: "red.600",
      borderColor: "red.600",
      bg: "red.50"
    },
    _active: {
      color: "red.700",
      borderColor: "red.700",
      bg: "red.100"
    }
  }, r = {
    color: "teal.500",
    borderColor: "teal.500",
    _hover: {
      color: "teal.600",
      borderColor: "teal.600",
      bg: "teal.100"
    },
    _active: {
      color: "teal.700",
      borderColor: "teal.700",
      bg: "teal.200"
    }
  };
  return {
    bg: "white",
    ...e.colorScheme === "red" ? o : r,
    ".chakra-button__group[data-attached] > &:not(:last-of-type)": {
      marginEnd: "-1px"
    }
  };
}), Kl = {
  tertiary: Xl,
  secondary: Zl,
  primary: Yl,
  ghost: ql
}, Jl = {
  lg: C({
    textStyle: "subheading2",
    minH: { base: 10, md: 12 },
    minW: { base: 10, md: 12 },
    px: 6
  }),
  md: C({
    textStyle: "bodyBold",
    minH: { base: 8, md: 10 },
    minW: { base: 8, md: 10 },
    px: 4
  }),
  sm: C({
    textStyle: "bodyBoldSmall",
    minH: { base: 7, md: 8 },
    minW: { base: 7, md: 8 },
    px: 3
  })
}, Ql = {
  borderRadius: "lg",
  transitionProperty: "common",
  transitionDuration: "normal",
  border: "1px solid green",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.5,
    pointerEvents: "none",
    cursor: "not-allowed"
  }
}, ve = q({
  baseStyle: Ql,
  variants: Kl,
  sizes: Jl,
  defaultProps: {
    variant: "primary",
    size: "md"
  }
}), { defineMultiStyleConfig: es, definePartsStyle: Ce } = N(Wn.keys), ts = {
  sm: Ce({
    control: {
      h: 4,
      w: 4,
      marginTop: { base: "2px", md: "4px" }
    },
    label: {
      textStyle: "bodySmall"
    },
    icon: {
      fontSize: S.xs
    }
  }),
  md: Ce({
    control: {
      w: 5,
      h: 5,
      marginTop: "2px"
    },
    label: {
      textStyle: "body"
    },
    icon: {
      fontSize: S.md
    }
  })
}, os = Ce(({ size: e }) => {
  const o = ts[e];
  return {
    icon: {
      transitionProperty: "transform",
      transitionDuration: "normal",
      ...o.icon
    },
    container: {
      alignItems: "start",
      WebkitAlignItems: "start",
      _disabled: { cursor: "not-allowed" }
    },
    label: {
      color: "black",
      userSelect: "none",
      _disabled: { opacity: 0.5 },
      ...o.label
    },
    control: {
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      border: "2px solid",
      borderRadius: "base",
      borderColor: "gray.200",
      color: "white",
      backgroundColor: "white",
      ...o.control,
      _hover: {
        borderColor: "gray.300"
      },
      _checked: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white",
        _hover: {
          bg: "teal.600",
          borderColor: "teal.600"
        },
        _disabled: {
          borderColor: "gray.200",
          bg: "gray.200",
          color: "gray.500"
        }
      },
      _indeterminate: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white"
      },
      _disabled: {
        bg: "gray.200",
        borderColor: "gray.200",
        opacity: 0.5
      },
      _focusVisible: {
        boxShadow: "outline"
      },
      _invalid: {
        borderColor: "red.500",
        _focusVisible: {
          boxShadow: "invalidOutline"
        }
      }
    }
  };
}), rs = Ce(() => ({
  size: {},
  icon: { display: "none" },
  container: {
    borderColor: "gray.200",
    borderWidth: "1px",
    borderRadius: "lg",
    bg: "white",
    p: 4,
    pb: 10,
    width: "fit-content",
    textStyle: "body",
    _hover: {
      borderColor: "teal.700",
      bg: "teal.50",
      _disabled: {
        borderColor: "gray.200",
        bg: "initial"
      }
    },
    _focusWithin: {
      p: "15px",
      pb: "39px",
      borderColor: "teal.500",
      borderWidth: "2px",
      boxShadow: "outline"
    },
    _checked: {
      borderColor: "teal.500",
      bg: "teal.25",
      ".checkbox-card-selected-badge": {
        display: "inline-block"
      },
      _hover: {
        borderColor: "teal.700",
        bg: "teal.50"
      },
      svg: { display: "none" }
    },
    _invalid: {
      p: "15px",
      pb: "39px",
      borderColor: "red.500",
      borderWidth: "2px",
      bg: "white",
      _focusWithin: {
        boxShadow: "invalidOutline"
      },
      _hover: {
        borderColor: "inherit"
      }
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  },
  label: {
    m: 0,
    w: "100%",
    ".checkbox-card-badge-container": {
      textAlign: "right",
      lineHeight: "0",
      height: { base: "20px", md: "24px" }
    },
    ".checkbox-card-selected-badge": {
      display: "none"
    }
  }
})), ns = Ce(({ size: e, ...o }) => {
  var n;
  const r = (n = ve.sizes) == null ? void 0 : n[e];
  return {
    icon: { display: "none" },
    container: {
      width: "fit-content",
      ...ve.baseStyle,
      ...r,
      color: "teal.500",
      bg: "white",
      border: "1px solid",
      borderColor: "gray.200",
      _focusWithin: {
        boxShadow: "outline"
      },
      _checked: {
        color: "teal.700",
        bg: "gray.200",
        svg: { display: "none" }
      },
      _invalid: {
        boxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        webkitBoxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        color: "teal.500",
        _focusWithin: {
          boxShadow: "invalidOutline"
        }
      }
    },
    label: { m: 0 }
  };
}), as = es({
  baseStyle: {},
  variants: {
    checkbox: os,
    card: rs,
    button: ns
  },
  defaultProps: {
    size: "md",
    variant: "checkbox"
  }
}), { defineMultiStyleConfig: is } = N(["container", "arrows"]), ls = is({
  baseStyle: ({ theme: e, ...o }) => ({
    container: {
      position: "relative",
      shadow: "lg",
      backgroundColor: "white",
      border: "none!important",
      pb: 3,
      px: 4,
      pt: 5,
      borderRadius: "8px !important",
      ".react-datepicker__day-name, .react-datepicker__time-name": {
        display: "inline-block",
        width: "38px",
        textAlign: "center",
        margin: 0.5
      },
      ".react-datepicker__day": {
        display: "inline-block",
        color: "gray.800",
        width: "42px",
        textAlign: "center",
        height: "32px",
        mx: 0,
        my: 0.5,
        _hover: {
          background: "teal.50",
          cursor: "pointer"
        },
        ...e.textStyles.body,
        lineHeight: "32px",
        borderRadius: "8px",
        "&--outside-month": {
          color: "gray.600"
        }
      },
      ".react-datepicker__month": {
        px: 0,
        pt: 0,
        mb: 3,
        m: 0
      },
      ".react-datepicker__day--today": {
        background: "inherit",
        color: "teal.500",
        fontWeight: "bold"
      },
      ".react-datepicker__day--selected, .react-datepicker__day--keyboard-selected": {
        background: "teal.200",
        color: "gray.800"
      },
      ".react-datepicker__day--in-range": {
        borderRadius: 0,
        background: "teal.50"
      },
      ".react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selecting-range-end, .react-datepicker__day--range-start)": {
        background: "teal.50",
        borderRadius: 0
      },
      ".react-datepicker__day--range-start, .react-datepicker__day--selecting-range-start:not(.react-datepicker__day--range-end)": {
        background: "teal.200",
        borderRightRadius: 0,
        borderLeftRadius: "8px",
        color: "gray.800"
      },
      ".react-datepicker__day--range-end, .react-datepicker__day--selecting-range-end:not(.react-datepicker__day--range-start)": {
        background: "teal.200",
        borderLeftRadius: 0,
        borderRightRadius: "8px",
        color: "gray.800"
      },
      ".react-datepicker__day-name": {
        width: "36px",
        textTransform: "uppercase",
        ...e.textStyles.bodySmall,
        color: "gray.600"
      },
      ".react-datepicker__day--disabled": {
        color: "gray.600",
        cursor: "not-allowed"
      },
      ".react-datepicker__header": {
        borderBottom: "none!important",
        backgroundColor: "transparent"
      },
      ".react-datepicker__today-button": {
        ...e.components.Button.variants.ghost({ theme: e, ...o }),
        borderTop: "none !important",
        mt: 1,
        py: 0,
        textAlign: "center",
        ...e.textStyles.bodyBoldSmall,
        "&:hover": {
          cursor: "pointer"
        }
      }
    }
  })
}), { defineMultiStyleConfig: ss, definePartsStyle: cs } = N([
  "container",
  "leftElement",
  "rightElement"
]), ds = cs({
  container: {},
  leftElement: {
    ".dual-input-left": {
      borderEndRadius: "none"
    },
    ".dual-input-left-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    }
  },
  rightElement: {
    ".dual-input-right": {
      borderStartRadius: "none"
    },
    ".dual-input-right-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    }
  }
}), ps = ss({
  baseStyle: ds
}), { defineMultiStyleConfig: us } = N(Hn.keys), bs = us({
  baseStyle: {
    container: {
      width: "100%",
      position: "relative",
      "span.label-optional": {
        textStyle: "bodySmall",
        lineHeight: "20px",
        color: "gray.600",
        pl: "2"
      }
    },
    requiredIndicator: {
      marginStart: 1,
      color: "red.500"
    },
    helperText: {
      textStyle: "bodySmall",
      mt: { base: 1, md: 2 },
      color: "gray.600",
      ".password-requirement-status-icon": {
        width: { base: S.sm, md: S.md },
        height: { base: S.sm, md: S.md }
      }
    }
  }
}), hs = q({
  baseStyle: {
    textStyle: "bodyBold",
    marginEnd: 3,
    mb: { base: 1, md: 2 },
    transitionProperty: "common",
    transitionDuration: "normal"
  }
}), { defineMultiStyleConfig: gs } = N(Ln.keys), ms = gs({
  baseStyle: {
    text: {
      textStyle: "bodySmall",
      alignItems: "start",
      color: "red.500",
      display: "flex",
      mt: { base: 1, md: 2 }
    },
    icon: {
      marginEnd: { base: 1, md: 2 },
      marginTop: { base: 0, md: "2px" }
    }
  }
}), { defineMultiStyleConfig: fs, definePartsStyle: ys } = N(Gn.keys), xs = ys({
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focus: {
      color: "gray.800"
    },
    ":not(.dual-input-right)": {
      ":not(.dual-input-left)": {
        _invalid: {
          color: "gray.800",
          _focus: {
            boxShadow: "invalidOutline"
          }
        }
      }
    },
    "&.dual-input-left": {
      _invalid: {
        borderWidth: "2px 0 2px 2px",
        borderColor: "red.500",
        _focus: {
          boxShadow: "invalidOutline"
        }
      }
    },
    "&.dual-input-right": {
      _invalid: {
        borderWidth: "2px 2px 2px 0",
        borderColor: "red.500",
        _focus: {
          boxShadow: "invalidOutline"
        }
      }
    },
    '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration, &[type="search"]::-webkit-search-results-button, &[type="search"]::-webkit-search-results-decoration': {
      WebkitAppearance: "none"
    },
    '&[type="search"]::-ms-clear, &[type="search"]::-ms-reveal': {
      display: "none",
      width: "0",
      height: "0"
    },
    "&.search-input-with-button": {
      borderRightRadius: "none",
      borderRight: "none"
    }
  },
  element: {
    "&.search-input-left-element-icon": {
      width: "auto",
      color: "gray.400"
    },
    "&.input-clear-element button, &.password-view-toggle button": {
      minWidth: 7,
      minHeight: 7
    },
    ".ccinput-right-icon": {
      color: "gray.400"
    }
  },
  addon: {
    ".currencyinput-left-addon": {
      color: "gray.700"
    }
  }
}), ze = {
  md: C({
    textStyle: "body",
    px: 4,
    h: { base: 8, md: 10 },
    borderRadius: "lg",
    "&.search-input-with-button, &.password-input": {
      paddingLeft: "16px",
      paddingRight: { base: "56px", md: "64px" }
    },
    "&.search-input-no-button": {
      paddingLeft: { base: "38px", md: "40px" },
      paddingRight: { base: "56px", md: "64px" }
    },
    "+ .search-input-button": {
      minWidth: { base: 8, md: 10 },
      minHeight: { base: 8, md: 10 },
      fontSize: { base: S.lg, md: S.xl }
    },
    ".currencyinput-left-addon": {
      fontSize: { base: S.sm, md: S.md }
    }
  }),
  sm: C({
    textStyle: "bodySmall",
    px: 3,
    h: { base: 7, md: 8 },
    borderRadius: "lg",
    "&.search-input-with-button, &.password-input": {
      paddingLeft: "12px",
      paddingRight: { base: "48px", md: "52px" }
    },
    "&.search-input-no-button": {
      paddingLeft: { base: "32px", md: "34px" },
      paddingRight: { base: "48px", md: "52px" }
    },
    "+ .search-input-button": {
      minWidth: { base: 7, md: 8 },
      minHeight: { base: 7, md: 8 },
      fontSize: { base: S.sm, md: S.md }
    },
    ".currencyinput-left-addon": {
      fontSize: { base: S.xs, md: S.sm }
    }
  })
}, R = fs({
  baseStyle: xs,
  sizes: {
    md: {
      field: ze.md,
      addon: ze.md,
      element: {
        "&.search-input-left-element-icon": {
          marginLeft: 4,
          fontSize: { base: S.sm, md: S.md }
        },
        "&.input-clear-element, &.password-view-toggle": {
          right: 4
        },
        "&.search-button-repos": {
          right: { base: "48px", md: "56px" }
        },
        "&.input-clear-element button, &.password-view-toggle button": {
          width: { base: 8, md: 10 },
          height: { base: 8, md: 10 },
          fontSize: { base: S.lg, md: S.xl }
        },
        "+ .search-input-button": {
          minWidth: { base: 8, md: 10 },
          minHeight: { base: 8, md: 10 },
          fontSize: { base: S.lg, md: S.xl }
        },
        ".ccinput-right-icon": {
          fontSize: S["2xl"]
        }
      }
    },
    sm: {
      field: ze.sm,
      addon: ze.sm,
      element: {
        "&.search-input-left-element-icon": {
          marginLeft: 3,
          fontSize: { base: S.xs, md: S.sm }
        },
        "&.input-clear-element, &.password-view-toggle": {
          right: 3
        },
        "&.search-button-repos": {
          right: { base: "40px", md: "44px" }
        },
        "&.input-clear-element button, &.password-view-toggle button": {
          width: { base: 7, md: 8 },
          height: { base: 7, md: 8 },
          fontSize: { base: S.sm, md: S.md }
        },
        "+ .search-input-button": {
          minWidth: { base: 7, md: 8 },
          minHeight: { base: 7, md: 8 },
          fontSize: { base: S.sm, md: S.md }
        },
        ".ccinput-right-icon": {
          fontSize: S.xl
        }
      }
    }
  },
  variants: {
    outline: {
      field: {
        color: "gray.600",
        border: "1px solid",
        borderColor: "gray.200",
        bg: "inherit",
        _hover: {
          borderColor: "gray.300"
        },
        _focus: {
          borderColor: "teal.500",
          borderWidth: "2px",
          boxShadow: "outline"
        },
        _focusVisible: {
          borderColor: "teal.500",
          borderWidth: "2px"
        },
        _readOnly: {
          userSelect: "all"
        },
        ":not(.dual-input-left)": {
          ":not(.dual-input-right)": {
            _invalid: {
              borderWidth: "2px",
              borderColor: "red.500"
            }
          }
        },
        _disabled: {
          opacity: 0.5,
          cursor: "not-allowed",
          _hover: {
            borderColor: "gray.200"
          }
        }
      },
      addon: {
        border: "1px solid",
        borderColor: "gray.200",
        bg: "gray.100"
      }
    },
    filled: {
      field: {
        color: "gray.800",
        border: "1px solid",
        borderColor: "transparent",
        bg: "gray.50",
        _hover: {
          bg: "gray.100"
        },
        _focus: {
          bg: "inherit",
          borderColor: "teal.500",
          borderWidth: "2px",
          boxShadow: "outline"
        },
        _focusVisible: {
          bg: "inherit",
          borderColor: "teal.500",
          borderWidth: "2px"
        },
        _readOnly: {
          boxShadow: "none !important",
          userSelect: "all"
        },
        ":not(.dual-input-right)": {
          ":not(.dual-input-left)": {
            _invalid: {
              borderColor: "red.500",
              bg: "inherit",
              borderWidth: "2px",
              _hover: {
                bg: "inherit"
              }
            }
          }
        },
        _disabled: {
          opacity: 0.5,
          cursor: "not-allowed",
          _hover: {
            bg: "gray.50"
          }
        }
      },
      addon: {
        border: "1px solid",
        borderColor: "transparent",
        bg: "gray.100",
        "~ hr": {
          border: "0px solid",
          borderWidth: "0 0 0 1px",
          borderColor: "gray.200",
          height: "auto"
        }
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), { defineMultiStyleConfig: Ss, definePartsStyle: vs } = N(On.keys);
var Zt;
const Cs = vs({
  field: {
    ...(Zt = R.baseStyle) == null ? void 0 : Zt.field
  },
  stepperGroup: {
    flexDirection: "row",
    color: "teal.500"
  },
  stepper: {
    borderStart: "1px solid",
    borderStartColor: "gray.200",
    _last: {
      pb: "4px",
      borderRightRadius: "lg"
    },
    _active: {
      bg: "gray.200"
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  }
});
var Kt, Jt, Qt, eo;
const ws = Ss({
  baseStyle: Cs,
  sizes: {
    md: {
      field: (Kt = R.sizes) == null ? void 0 : Kt.md.field,
      stepperGroup: {
        width: "80px",
        fontSize: "12px"
      }
    },
    sm: {
      field: (Jt = R.sizes) == null ? void 0 : Jt.sm.field,
      stepperGroup: {
        width: "64px",
        fontSize: "10px"
      }
    }
  },
  variants: {
    outline: {
      field: (Qt = R.variants) == null ? void 0 : Qt.outline.field
    },
    filled: {
      field: (eo = R.variants) == null ? void 0 : eo.filled.field
    }
  },
  defaultProps: R.defaultProps
}), { defineMultiStyleConfig: ks, definePartsStyle: we } = N(Vn.keys), $s = {
  md: we({
    control: {
      w: 5,
      h: 5,
      marginTop: "2px"
    },
    label: { textStyle: "body" }
  }),
  sm: we({
    control: {
      width: 4,
      height: 4,
      marginTop: { base: "2px", md: "4px" }
    },
    label: { textStyle: "bodySmall" }
  })
}, _s = we(({ size: e }) => {
  const o = $s[e];
  return {
    container: {
      alignItems: "start",
      WebkitAlignItems: "start",
      _disabled: { cursor: "not-allowed" }
    },
    label: {
      color: "black",
      userSelect: "none",
      _disabled: { opacity: 0.5 },
      ...o.label
    },
    control: {
      borderRadius: "full",
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      border: "2px solid",
      borderColor: "gray.200",
      color: "white",
      ...o.control,
      _hover: {
        borderColor: "gray.300"
      },
      _checked: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white",
        _before: {
          content: '""',
          display: "inline-block",
          pos: "relative",
          w: "50%",
          h: "50%",
          borderRadius: "50%",
          bg: "currentColor"
        },
        _hover: {
          bg: "teal.600",
          borderColor: "teal.600"
        },
        _disabled: {
          borderColor: "gray.200",
          bg: "gray.200",
          color: "gray.500"
        }
      },
      _indeterminate: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white"
      },
      _disabled: {
        bg: "gray.200",
        borderColor: "gray.200",
        opacity: 0.5
      },
      _focusVisible: {
        boxShadow: "outline"
      },
      _invalid: {
        borderColor: "red.500",
        _focusVisible: {
          boxShadow: "invalidOutline"
        }
      }
    }
  };
}), Is = we(() => ({
  size: {},
  container: {
    borderColor: "gray.200",
    borderWidth: "1px",
    borderRadius: "lg",
    bg: "white",
    p: 4,
    pb: 10,
    width: "fit-content",
    textStyle: "body",
    w: "100%",
    h: "100%",
    alignItems: "start",
    _hover: {
      borderColor: "teal.700",
      bg: "teal.50",
      _disabled: {
        borderColor: "gray.200",
        bg: "initial"
      }
    },
    _focusWithin: {
      p: "15px",
      pb: "39px",
      borderColor: "teal.500",
      borderWidth: "2px",
      boxShadow: "outline"
    },
    _checked: {
      borderColor: "teal.500",
      bg: "teal.25",
      ".radio-card-selected-badge": {
        display: "inline-block"
      },
      _hover: {
        borderColor: "teal.700",
        bg: "teal.50"
      }
    },
    _invalid: {
      p: "15px",
      pb: "39px",
      borderColor: "red.500",
      borderWidth: "2px",
      bg: "white",
      _focusWithin: {
        boxShadow: "invalidOutline"
      },
      _hover: {
        borderColor: "inherit"
      }
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  },
  label: {
    m: 0,
    w: "100%",
    ".radio-card-badge-container": {
      textAlign: "right",
      lineHeight: "0",
      height: { base: "20px", md: "24px" }
    },
    ".radio-card-selected-badge": {
      display: "none"
    }
  },
  control: {}
})), zs = we(({ size: e, ...o }) => {
  var n;
  const r = (n = ve.sizes) == null ? void 0 : n[e];
  return {
    container: {
      width: "fit-content",
      ...ve.baseStyle,
      ...r,
      color: "teal.500",
      bg: "white",
      border: "1px solid",
      borderColor: "gray.200",
      _focusWithin: {
        boxShadow: "outline"
      },
      _checked: {
        color: "teal.700",
        bg: "gray.200"
      },
      _invalid: {
        boxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        webkitBoxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        color: "teal.500",
        _focusWithin: {
          boxShadow: "invalidOutline"
        }
      }
    },
    label: { m: 0 },
    control: {}
  };
}), Ms = ks({
  baseStyle: {},
  variants: {
    radio: _s,
    card: Is,
    button: zs
  },
  defaultProps: {
    size: "md",
    variant: "radio"
  }
}), { defineMultiStyleConfig: Ds } = N(jn.keys), Lt = C({ paddingInlineEnd: "2rem" });
var to;
const Bs = Ds({
  baseStyle: {
    field: {
      ...((to = R.baseStyle) == null ? void 0 : to.field) || {},
      bg: "white",
      appearance: "none",
      "> option, > optgroup": {
        bg: "white"
      }
    },
    icon: {
      width: "1.5rem",
      height: "100%",
      insetEnd: "0.5rem",
      position: "relative",
      color: "teal.500",
      _disabled: {
        opacity: 0.5
      },
      _groupHover: {
        color: "teal.600"
      },
      _groupFocusWithin: {
        color: "teal.700"
      }
    }
  },
  sizes: ea({}, R.sizes, {
    md: {
      field: Lt,
      icon: {
        fontSize: { base: S.sm, md: S.md }
      }
    },
    sm: {
      field: Lt,
      icon: {
        fontSize: { base: S.xs, md: S.sm }
      }
    }
  }),
  variants: R.variants,
  defaultProps: R.defaultProps
}), { defineMultiStyleConfig: Ns, definePartsStyle: Ps } = co(Un.keys), it = yt("slider-thumb-size"), lt = yt("slider-track-size"), Ae = yt("slider-bg"), As = X((e) => {
  const { orientation: o } = e;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none"
    },
    ...xt({
      orientation: o,
      vertical: { h: "100%", minH: "240px" },
      horizontal: { w: "100%" }
    })
  };
}), Ts = X((e) => ({
  ...xt({
    orientation: e.orientation,
    horizontal: { h: lt.reference },
    vertical: { w: lt.reference }
  }),
  overflow: "hidden",
  borderRadius: "full",
  [Ae.variable]: "colors.gray.200",
  bg: Ae.reference
})), Rs = X((e) => {
  const { orientation: o } = e;
  return {
    ...xt({
      orientation: o,
      vertical: {
        left: "50%",
        transform: "translateX(-50%)"
      },
      horizontal: {
        top: "50%",
        transform: "translateY(-50%)"
      }
    }),
    w: it.reference,
    h: it.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _hover: {
      bg: "gray.50"
    },
    _focusVisible: {
      bg: "white",
      boxShadow: "outline"
    }
  };
}), Es = X((e) => ({
  width: "inherit",
  height: "inherit",
  [Ae.variable]: "colors.teal.500",
  bg: Ae.reference
})), Fs = Ps((e) => ({
  container: As(e),
  track: Ts(e),
  thumb: Rs(e),
  filledTrack: Es(e)
})), Ws = {
  md: {
    container: {
      [it.variable]: "sizes.4",
      [lt.variable]: "sizes.1.5"
    }
  }
}, Hs = Ns({
  baseStyle: Fs,
  sizes: Ws,
  defaultProps: {
    size: "md"
  }
}), { defineMultiStyleConfig: Ls, definePartsStyle: st } = N(Yn.keys), Te = Z("switch-track-width"), de = Z("switch-track-height"), Ke = Z("switch-track-diff"), Gs = po.subtract(Te, de), ct = Z("switch-thumb-x"), Os = C({
  borderRadius: "full",
  p: "2px",
  width: [Te.reference],
  height: [de.reference],
  transitionProperty: "common",
  transitionDuration: "fast",
  bg: "gray.300",
  _hover: {
    bg: "gray.400"
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    _hover: {
      bg: "gray.300"
    }
  },
  _checked: {
    bg: "teal.500",
    _hover: {
      bg: "teal.600"
    },
    _disabled: {
      _hover: {
        bg: "teal.500"
      }
    }
  }
}), Vs = C({
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [de.reference],
  height: [de.reference],
  _checked: {
    transform: `translateX(${ct.reference})`
  }
}), js = st({
  container: {
    display: "flex",
    alignItems: "center",
    [Ke.variable]: Gs,
    [ct.variable]: Ke.reference,
    _rtl: {
      [ct.variable]: po(Ke).negate().toString()
    }
  },
  track: Os,
  thumb: Vs
}), Us = {
  sm: st({
    container: {
      [Te.variable]: "1.375rem",
      [de.variable]: "0.75rem"
    }
  }),
  md: st({
    container: {
      [Te.variable]: "1.875rem",
      [de.variable]: "1rem"
    }
  })
}, Ys = Ls({
  baseStyle: js,
  sizes: Us,
  defaultProps: { size: "md", colorScheme: "blue" }
});
var oo, ro;
const qs = q({
  baseStyle: {
    ...(oo = R.baseStyle) == null ? void 0 : oo.field,
    paddingY: "8px",
    minHeight: "80px",
    lineHeight: "short",
    verticalAlign: "top"
  },
  sizes: {
    sm: R.sizes.sm.field,
    md: R.sizes.md.field
  },
  variants: {
    outline: R.variants.outline.field,
    filled: R.variants.filled.field
  },
  defaultProps: {
    size: (ro = R.defaultProps) == null ? void 0 : ro.size,
    variant: "outline"
  }
}), { defineMultiStyleConfig: Xs, definePartsStyle: Zs } = N(qn.keys), Ks = C((e) => {
  const { name: o } = e;
  return {
    bg: o ? "teal.500" : "gray.200",
    color: "white",
    borderColor: "white",
    verticalAlign: "top"
  };
}), Js = Zs((e) => ({
  container: Ks(e),
  label: {
    textStyle: "body"
  }
}));
function Je(e) {
  return {
    container: {
      width: e,
      height: e
    },
    excessLabel: {
      width: e,
      height: e
    }
  };
}
const Qs = {
  sm: {
    ...Je(8),
    label: {
      textStyle: "bodySmall"
    }
  },
  md: Je(12),
  lg: {
    ...Je(32),
    label: {
      fontWeight: "300",
      fontSize: "48px",
      lineHeight: "56px"
    }
  }
}, ec = Xs({
  baseStyle: Js,
  sizes: Qs,
  defaultProps: {
    size: "md"
  }
}), dt = q({
  baseStyle: {
    textStyle: "bodyBold",
    color: "teal.500",
    textDecorationLine: "underline",
    textDecorationColor: "teal.500",
    _hover: {
      color: "teal.600",
      textDecorationColor: "teal.600"
    },
    _active: {
      color: "teal.700",
      textDecorationColor: "teal.700"
    },
    _focusVisible: {
      outline: "none",
      boxShadow: "outline"
    }
  },
  sizes: {
    sm: {
      textStyle: "bodyBoldSmall"
    },
    md: {
      textStyle: "bodyBold"
    }
  },
  defaultProps: {
    size: "md"
  }
}), { defineMultiStyleConfig: tc } = N(Xn.keys);
var no;
const oc = tc({
  baseStyle: {
    container: {
      color: "gray.800",
      '[aria-current="page"]': {
        color: "gray.800",
        textDecoration: "none"
      }
    },
    separator: {
      textStyle: "bodySmall"
    },
    link: {
      transitionProperty: "common",
      transitionDuration: "fast",
      transitionTimingFunction: "ease-out",
      cursor: "pointer",
      ...dt.baseStyle,
      ...(no = dt.sizes) == null ? void 0 : no.sm
    }
  }
}), rc = N(["container"]), nc = rc.defineMultiStyleConfig({
  baseStyle: {
    container: {
      bg: "white",
      px: "6",
      alignItems: "center",
      h: "60px",
      flexDir: "row"
    }
  },
  variants: {},
  defaultProps: {}
}), { defineMultiStyleConfig: ac, definePartsStyle: wt } = N([
  "stepDetails",
  "icon",
  "container",
  "stepProgress",
  "scrollable"
]), ic = wt({
  container: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: { base: 1, md: 2 },
    ".disable-pointer-events": {
      pointerEvents: "none"
    }
  },
  stepDetails: {
    cursor: "pointer",
    flexDirection: "row",
    flexWrap: { base: "nowrap", md: "wrap" },
    alignItems: { base: "center", md: "flex-start" },
    ".step-label": {
      textStyle: "bodyBoldSmall",
      order: 3,
      display: { base: "none", md: "flex" },
      width: "calc(100% - 28px - 8px)"
    },
    _hover: {
      color: "teal.600",
      ".step-progress": {
        bg: "teal.600"
      },
      svg: {
        color: "inherit"
      }
    },
    _active: {
      color: "teal.700",
      ".step-progress": {
        bg: "gray.200"
      },
      svg: {
        color: "inherit"
      }
    },
    _focusVisible: {
      outline: "none",
      boxShadow: "outline"
    }
  },
  icon: {
    display: "flex",
    mt: { base: 0, md: 0.5 },
    color: "gray.600",
    order: { base: 1, md: 2 },
    flexGrow: 0,
    flexShrink: 0
  },
  stepProgress: {
    height: 1,
    bg: "gray.200",
    w: "100%",
    mb: { base: 0, md: 4 },
    order: { base: 2, md: 1 }
  },
  scrollable: {
    overflowX: "scroll",
    position: "relative",
    "::-webkit-scrollbar": {
      display: "none",
      msOverflowStyle: "none",
      scrollbarWidth: "none"
    }
  }
}), lc = wt({
  stepDetails: {
    color: "teal.700",
    svg: {
      color: "inherit"
    },
    '[role="progressbar"]': {
      bg: "teal.700"
    },
    _hover: {
      color: "teal.700",
      ".step-progress": {
        bg: "gray.200"
      }
    }
  }
}), sc = wt({
  stepDetails: {
    color: "teal.500",
    svg: {
      color: "inherit"
    },
    '[role="progressbar"]': {
      bg: "teal.500"
    },
    _hover: {
      color: "teal.600",
      '[role="progressbar"]': {
        bg: "teal.600"
      }
    }
  }
}), cc = ac({
  baseStyle: ic,
  variants: {
    active: lc,
    complete: sc
  }
}), { defineMultiStyleConfig: dc, definePartsStyle: pc } = N([
  "container",
  "content",
  "graphic"
]), uc = pc({
  container: {
    flexDirection: "row",
    minWidth: "max-content",
    gap: "40px"
  },
  content: {
    p: { base: "16px", md: "40px" },
    flex: 1
  },
  graphic: {}
}), bc = dc({
  baseStyle: uc
}), Se = Z("close-button-size"), hc = C({
  color: "gray.700",
  w: [Se.reference],
  h: [Se.reference],
  borderRadius: "lg",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    color: "gray.800",
    opacity: 0.5,
    cursor: "not-allowed",
    boxShadow: "none",
    _hover: { bg: "none" }
  },
  _hover: { bg: "blackAlpha.100" },
  _active: { bg: "blackAlpha.200" },
  _focusVisible: {
    boxShadow: "outline"
  }
}), gc = {
  lg: C({
    [Se.variable]: "40px",
    fontSize: "15px"
  }),
  md: C({
    [Se.variable]: "32px",
    fontSize: "15px"
  }),
  sm: C({
    [Se.variable]: "24px",
    fontSize: "10px"
  })
}, mc = q({
  baseStyle: hc,
  sizes: gc,
  defaultProps: {
    size: "md"
  }
}), fc = (e) => typeof e == "function";
function Gt(e, ...o) {
  return fc(e) ? e(...o) : e;
}
const Re = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, { defineMultiStyleConfig: yc, definePartsStyle: xc } = N(Zn.keys), Sc = C({
  bg: "white",
  boxShadow: "lg",
  minW: "3xs",
  p: "2",
  zIndex: Re.popover,
  borderRadius: "lg",
  borderWidth: "1px",
  borderColor: "gray.200",
  gap: "4px 0px",
  display: "flex",
  flexWrap: "wrap",
  flexDir: "column"
}), vc = C({
  textStyle: "bodySmall",
  py: "0.5",
  px: "2",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  alignItems: "start",
  _focus: {
    color: "inherit",
    bg: "gray.100",
    borderRadius: "lg"
  },
  _hover: {
    color: "inherit",
    bg: "gray.100",
    borderRadius: "lg"
  },
  _active: {
    color: "inherit",
    bg: "teal.100",
    borderRadius: "lg"
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    _active: { bg: "inherit" },
    _focus: { bg: "inherit" }
  }
}), Cc = C({
  mx: 2,
  my: 1,
  textStyle: "bodyBoldSmall"
}), wc = C({
  opacity: 0.6
}), kc = C({
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}), $c = C({
  transitionProperty: "common",
  transitionDuration: "normal",
  textStyle: "body",
  _focus: {
    boxShadow: "outline"
  }
}), _c = xc((e) => ({
  button: $c,
  list: Gt(Sc, e),
  item: Gt(vc, e),
  groupTitle: Cc,
  command: wc,
  divider: kc
})), Ic = yc({
  baseStyle: _c
}), { defineMultiStyleConfig: zc, definePartsStyle: Mc } = N(Kn.keys), Dc = C({
  bg: "blackAlpha.400",
  zIndex: "modal"
}), Bc = C((e) => {
  const { isCentered: o, scrollBehavior: r } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: o ? "center" : "flex-start",
    overflow: r === "inside" ? "hidden" : "auto"
  };
}), Nc = C((e) => {
  const { scrollBehavior: o } = e;
  return {
    borderRadius: "lg",
    bg: "white",
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: o === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: "xl",
    p: 6
  };
}), Pc = C({
  textStyle: "subheading2",
  mb: 2,
  pr: "44px"
}), Ac = C({
  position: "absolute",
  top: 6,
  right: 6
}), Tc = C((e) => {
  const { scrollBehavior: o } = e;
  return {
    textStyle: "body",
    flex: 1,
    overflow: o === "inside" ? "auto" : void 0
  };
}), Rc = C({
  mt: 6
}), Ec = Mc((e) => ({
  overlay: Dc,
  dialogContainer: Bc(e),
  dialog: Nc(e),
  header: Pc,
  closeButton: Ac,
  body: Tc(e),
  footer: Rc
})), Qe = (e) => e === "full" ? {
  dialog: {
    maxW: "100vw",
    minH: "100vh",
    "@supports(min-height: -webkit-fill-available)": {
      minH: "-webkit-fill-available"
    },
    my: 0,
    borderRadius: "none"
  }
} : {
  dialog: { maxW: e }
}, Fc = {
  sm: Qe("sm"),
  xl: Qe("xl"),
  full: Qe("full")
}, Wc = zc({
  baseStyle: Ec,
  sizes: Fc,
  defaultProps: {
    size: "xl"
  }
}), { defineMultiStyleConfig: Hc, definePartsStyle: Lc } = N(Jn.keys), et = ut("popper-bg"), Gc = ut("popper-arrow-bg"), Oc = ut("popper-arrow-shadow-color"), Vc = {
  md: Lc({ body: { maxW: "md" } })
}, jc = Hc({
  baseStyle: {
    popper: {
      zIndex: "popover"
    },
    content: {
      border: "1px solid",
      borderColor: "gray.200",
      borderRadius: "lg",
      boxShadow: "lg",
      zIndex: "inherit",
      [et.variable]: "colors.white",
      bg: et.reference,
      [Gc.variable]: et.reference,
      [Oc.variable]: "colors.gray.200",
      _focusVisible: {
        outline: 0,
        boxShadow: "outline"
      },
      ".headerspacer": {
        height: "20px"
      }
    },
    header: {
      paddingLeft: 4,
      paddingRight: 10,
      py: 2,
      borderBottomWidth: "1px",
      borderColor: "gray.200",
      textStyle: "bodyBoldSmall"
    },
    body: {
      py: 2,
      px: 4,
      textStyle: "bodySmall"
    },
    footer: {
      px: 3,
      py: 2,
      borderTopWidth: "1px",
      borderColor: "gray.200"
    },
    closeButton: {
      position: "absolute",
      top: 1,
      insetEnd: 1
    }
  },
  sizes: Vc,
  defaultProps: {
    size: "md"
  }
}), Ot = Z("tooltip-bg"), Uc = Z("popper-arrow-bg"), Yc = q({
  baseStyle: {
    textStyle: "bodySmall",
    [Ot.variable]: "colors.gray.900",
    [Uc.variable]: [Ot.reference],
    px: 2,
    py: 2,
    bg: "gray.900",
    color: "white",
    borderRadius: "base",
    boxShadow: "lg",
    maxW: "320px",
    zIndex: "tooltip"
  }
}), { defineMultiStyleConfig: qc, definePartsStyle: eu } = N([
  "container",
  "chatIcon",
  "defaultContent"
]), Xc = qc({
  baseStyle: {
    container: {
      bg: "gray.50",
      p: "4",
      h: { base: "fit-content", md: "112px" },
      minH: "72px",
      position: "relative"
    },
    defaultContent: {
      flexDir: { base: "column", md: "row" },
      gap: "0px 16px",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
      mx: { base: "0", md: "80px" },
      "a, p": {
        textStyle: "bodySmall",
        textDecoration: "none"
      }
    },
    chatIcon: {
      borderRadius: "full",
      position: "absolute",
      right: { base: "16px", md: "40px" },
      top: { base: "16px", md: "32px" }
    }
  },
  variants: {
    stickToBottom: {
      container: {
        bottom: "0",
        left: "0",
        position: "fixed",
        zIndex: "1000",
        width: "100%"
      }
    }
  }
}), { defineMultiStyleConfig: Zc } = N([
  "globalNavTopContainer",
  "globalNavNavContainer",
  "globalNavCategory",
  "globalNavCategoryIcon",
  "globalNavMenu",
  "globalNavMenuSlider",
  "globalNavMenuLink",
  "globalNavSubMenu",
  "globalNavSubMenuLink",
  "globalNavMenuDivider"
]), Be = 94, Kc = 334, Jc = Zc({
  baseStyle: {
    globalNavTopContainer: {
      minH: "100vh",
      pos: "sticky",
      bg: "teal.500",
      zIndex: Re.modal
    },
    globalNavNavContainer: {
      w: `${Be}px`,
      h: "full"
    },
    globalNavCategory: {
      w: `${Be}px`,
      mx: "auto",
      borderBottom: "1px solid white",
      borderColor: "blackAlpha.200",
      cursor: "pointer",
      display: "block",
      pt: 4,
      px: 2,
      pb: "15px",
      textDecoration: "none",
      "& p": {
        color: "white",
        textStyle: "bodyBoldSmall",
        lineHeight: "20px",
        textAlign: "center"
      },
      _hover: {
        backgroundColor: "white",
        "& p": {
          color: "gray.800"
        },
        "& svg": {
          color: "gray.800"
        }
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline",
        backgroundColor: "white",
        "& p": {
          color: "gray.800"
        },
        "& svg": {
          color: "gray.800"
        }
      }
    },
    globalNavCategoryIcon: {
      ...vt["2xl"],
      color: "white",
      fill: "currentColor"
    },
    globalNavMenu: {
      m: "6"
    },
    globalNavMenuSlider: {
      overflow: "hidden",
      whiteSpace: "nowrap",
      position: "absolute",
      left: `${Be}px`,
      height: "full",
      minHeight: "100%",
      top: "0",
      backgroundColor: "white",
      boxShadow: "18px 28px 24px rgba(0, 0, 0, 0.04)",
      borderRight: "1px solid #D3D4D6",
      zIndex: Re.modal
    },
    globalNavMenuLink: {
      textStyle: "bodyBoldSmall",
      color: "green.900",
      textDecoration: "none",
      _hover: {},
      _active: {},
      _focusVisible: {
        outline: "none",
        boxShadow: "outline"
      }
    },
    globalNavSubMenu: {
      mt: "2"
    },
    globalNavSubMenuLink: {
      py: "0.5",
      px: "4",
      textStyle: "bodySmall",
      color: "teal.600",
      textDecoration: "none",
      _hover: {
        backgroundColor: "gray.100",
        borderRadius: "lg",
        color: "teal.700"
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline",
        backgroundColor: "gray.100",
        borderRadius: "lg",
        color: "teal.700"
      }
    },
    globalNavMenuDivider: {
      borderColor: "blackAlpha.400"
    }
  },
  variants: {
    disabled: {
      globalNavMenuLink: {
        cursor: "not-allowed",
        opacity: 0.5
      },
      globalNavSubMenuLink: {
        cursor: "not-allowed",
        opacity: 0.5,
        _hover: {
          backgroundColor: "none"
        }
      }
    },
    active: {
      globalNavCategory: {
        backgroundColor: "teal.400",
        boxShadow: "inset 6px 0 #99C7CC",
        "& p": {
          color: "white"
        },
        "& svg": {
          color: "white"
        }
      },
      globalNavMenuLink: {
        pl: "3",
        backgroundColor: "gray.100",
        borderLeftWidth: "4px",
        borderStyle: "solid",
        borderColor: "gray.900"
      },
      globalNavSubMenuLink: {
        backgroundColor: "teal.100",
        color: "teal.700",
        borderRadius: "lg"
      }
    },
    open: {
      globalNavCategory: {
        backgroundColor: "white",
        "& p": {
          color: "gray.800"
        },
        "& svg": {
          color: "gray.800"
        }
      }
    }
  },
  defaultProps: {}
}), Qc = {
  none: 0,
  "1px": "1px solid"
}, ed = {
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "90em"
}, go = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F4F4F5",
    100: "#E9EAEA",
    200: "#D3D4D6",
    300: "#BDBFC1",
    400: "#A7A9AD",
    500: "#919498",
    600: "#74767A",
    700: "#57595B",
    800: "#3A3B3D",
    900: "#1D1E1E"
  },
  teal: {
    25: "#F2F8F9",
    50: "#E6F1F2",
    100: "#CCE3E6",
    200: "#99C7CC",
    300: "#66ACB3",
    400: "#339099",
    500: "#007480",
    600: "#005D66",
    700: "#00464D",
    800: "#002E33",
    900: "#00171A"
  },
  blue: {
    50: "#EBF8FF",
    100: "#BEE3F8",
    200: "#90CDF4",
    300: "#63B3ED",
    400: "#4299E1",
    500: "#3182CE",
    600: "#2B6CB0",
    700: "#2C5282",
    800: "#2A4365",
    900: "#1A365D"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#25855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#DA3A3A",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBCB",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  }
}, td = {
  none: "0",
  base: "4px",
  lg: "8px",
  "2xl": "16px",
  full: "9999px"
}, od = {
  none: "none",
  outline: "0 0 0 3px var(--sgi-colors-teal-200)",
  invalidOutline: "0 0 0 3px var(--sgi-colors-red-200)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
}, mo = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, rd = {
  max: "max-content",
  min: "min-content",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  full: "100%"
}, nd = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, ad = {
  ...mo,
  ...rd,
  container: nd
}, id = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, ld = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, sd = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, cd = {
  property: id,
  easing: ld,
  duration: sd
}, dd = {
  body: "'Open Sans', sans-serif",
  heading: "'Merriweather', sans-serif"
}, pd = {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "24px",
  "3xl": "36px",
  "4xl": "48px"
}, ud = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
}, bd = {
  normal: "normal",
  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: "2"
}, hd = {
  tighter: "-0.05em",
  tight: "-0.025em",
  normal: "0",
  wide: "0.025em",
  wider: "0.05em",
  widest: "0.1em"
}, gd = {
  h1: {
    fontFamily: "body",
    fontSize: { base: "3xl", md: "4xl" },
    fontWeight: "light",
    lineHeight: { base: "44px", md: "56px" }
  },
  h2: {
    fontFamily: "heading",
    fontSize: { base: "28px", md: "3xl" },
    fontWeight: "normal",
    lineHeight: { base: "40px", md: "48px" },
    fontVariantNumeric: "lining-nums"
  },
  h3: {
    fontFamily: "heading",
    fontSize: { base: "xl", md: "2xl" },
    fontWeight: "bold",
    lineHeight: { base: "32px", md: "36px" },
    fontVariantNumeric: "lining-nums"
  },
  h4: {
    fontFamily: "heading",
    fontSize: { base: "lg", md: "xl" },
    fontWeight: "bold",
    lineHeight: { base: "28px", md: "32px" },
    fontVariantNumeric: "lining-nums"
  },
  subheading1: {
    fontFamily: "body",
    fontSize: { base: "lg", md: "xl" },
    fontWeight: "bold",
    lineHeight: { base: "28px", md: "36px" },
    textTransform: "uppercase"
  },
  subheading2: {
    fontFamily: "body",
    fontSize: { base: "md", md: "lg" },
    fontWeight: "bold",
    lineHeight: { base: "24px", md: "28px" }
  },
  body: {
    fontFamily: "body",
    fontSize: { base: "sm", md: "md" },
    fontWeight: "normal",
    lineHeight: { base: "24px", md: "24px" }
  },
  bodyBold: {
    fontFamily: "body",
    fontSize: { base: "sm", md: "md" },
    fontWeight: "bold",
    lineHeight: { base: "24px", md: "24px" }
  },
  bodySmall: {
    fontFamily: "body",
    fontSize: { base: "xs", md: "sm" },
    fontWeight: "normal",
    lineHeight: { base: "20px", md: "24px" }
  },
  bodyBoldSmall: {
    fontFamily: "body",
    fontSize: { base: "xs", md: "sm" },
    fontWeight: "bold",
    lineHeight: { base: "20px", md: "24px" }
  }
}, md = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fonts: dd,
  fontSizes: pd,
  fontWeights: ud,
  lineHeights: bd,
  letterSpacings: hd,
  textStyles: gd
}, Symbol.toStringTag, { value: "Module" })), fd = {}, yd = {
  breakpoints: ed,
  zIndices: Re,
  radii: td,
  blur: fd,
  colors: go,
  ...Nl,
  ...md,
  sizes: ad,
  shadows: od,
  space: mo,
  borders: Qc,
  transition: cd
}, xd = {
  global: {
    body: {
      fontFamily: "body",
      transitionDuration: "normal",
      lineHeight: "base",
      color: "gray.800"
    },
    "*, *::before, &::after": {
      wordWrap: "break-word"
    },
    ".react-datepicker-popper": {
      zIndex: "popover"
    },
    '.react-datepicker-popper[data-placement^="bottom"]': {
      paddingTop: 2
    },
    '.react-datepicker-popper[data-placement^="top"]': {
      paddingBottom: 2
    },
    '.react-datepicker-popper[data-placement^="right"]': {
      paddingLeft: 2
    },
    '.react-datepicker-popper[data-placement^="left"]': {
      paddingRight: 2
    },
    ".react-datepicker__portal": {
      position: "fixed",
      width: "100vw",
      height: "100vh",
      background: "blackAlpha.800",
      left: 0,
      top: 0,
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      zIndex: 2147483647
    }
  }
}, Sd = "ltr", vd = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "sgi"
}, tu = {
  ...yd,
  styles: xd,
  components: {
    Accordion: tl,
    Alert: El,
    Avatar: ec,
    Badge: al,
    Breadcrumb: oc,
    Button: ve,
    Card: ll,
    Checkbox: as,
    CloseButton: mc,
    DatePicker: ls,
    DualInput: ps,
    Footer: Xc,
    Form: bs,
    FormError: ms,
    FormLabel: hs,
    GlobalHeader: nc,
    GlobalNav: Jc,
    Input: R,
    Link: dt,
    Logo: qi,
    Menu: Ic,
    Modal: Wc,
    NumberInput: ws,
    PageHeader: bc,
    Pagination: cl,
    Progress: Wl,
    Radio: Ms,
    ResponseError: Ll,
    Select: Bs,
    Skeleton: Ul,
    Slider: Hs,
    Spinner: Gl,
    Steps: cc,
    Switch: Ys,
    Table: ul,
    Tabs: Bl,
    Tag: vl,
    Textarea: qs,
    Tooltip: Yc,
    Typography: Cl,
    Popover: jc
  },
  config: vd,
  direction: Sd
}, Cd = () => /* @__PURE__ */ t("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 85.29 20.57",
  children: /* @__PURE__ */ b("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    children: [/* @__PURE__ */ t("path", {
      className: "cls-1",
      d: "M55.07,23.39l5.3-17.33a4.56,4.56,0,0,1,4.36-3.23H66.8l-5,16.48a5.77,5.77,0,0,1-5.52,4.08Z",
      transform: "translate(-4.66 -2.82)"
    }), /* @__PURE__ */ t("path", {
      className: "cls-2",
      d: "M62.44,23.39l5.47-17.9a3.76,3.76,0,0,1,3.6-2.66h1.25l-5.5,18a3.65,3.65,0,0,1-3.49,2.58Z",
      transform: "translate(-4.66 -2.82)"
    }), /* @__PURE__ */ t("path", {
      className: "cls-2",
      d: "M68.41,23.39,73.89,5.46a3.72,3.72,0,0,1,3.56-2.63h.92l-5.5,18a3.66,3.66,0,0,1-3.49,2.58Z",
      transform: "translate(-4.66 -2.82)"
    }), /* @__PURE__ */ t("path", {
      className: "cls-2",
      d: "M74.52,23.39,80.09,5.17a3.32,3.32,0,0,1,3.17-2.34h.64L78.3,21.15a3.17,3.17,0,0,1-3,2.24Z",
      transform: "translate(-4.66 -2.82)"
    }), /* @__PURE__ */ t("path", {
      className: "cls-2",
      d: "M81,23.39l5.6-18.32a3.18,3.18,0,0,1,3-2.24H90L84.35,21.17a3.13,3.13,0,0,1-3,2.22Z",
      transform: "translate(-4.66 -2.82)"
    }), /* @__PURE__ */ t("path", {
      className: "cls-1",
      d: "M40.4,11h0a4.29,4.29,0,0,0,4.3,4.3h6.16l-1.07,3.5H35.07l3.46-11.3H52.78a4.62,4.62,0,0,0,4.41-3.26l.42-1.37H38.72a4.6,4.6,0,0,0-4.41,3.26L30.57,18.32a3.92,3.92,0,0,0,3.75,5.07h16a3.68,3.68,0,0,0,3.52-2.61l1.51-4.93A3.8,3.8,0,0,0,51.68,11Z",
      transform: "translate(-4.66 -2.82)"
    }), /* @__PURE__ */ t("path", {
      className: "cls-1",
      d: "M11.41,11l1.07-3.5H26.71a4.64,4.64,0,0,0,4.44-3.28l.41-1.35H12.68A4.6,4.6,0,0,0,8.27,6.08L6.77,11a3.29,3.29,0,0,0,3.15,4.25H24.81l-1.07,3.5H10.32a5.74,5.74,0,0,0-5.48,4.06l-.18.58H24.23a3.69,3.69,0,0,0,3.53-2.61l1.56-5.1A3.66,3.66,0,0,0,25.82,11Z",
      transform: "translate(-4.66 -2.82)"
    })]
  })
}), wd = ({
  variant: e = "colour",
  ...o
}) => {
  const r = Qo("Logo", {
    variant: e
  });
  return /* @__PURE__ */ t(ne.span, {
    __css: r,
    ...o,
    children: /* @__PURE__ */ t(Cd, {})
  });
}, kd = {
  neutral: "gray",
  error: "red",
  success: "green",
  warning: "orange",
  info: "blue",
  recommendation: "teal"
}, kt = ({
  children: e,
  status: o = "neutral",
  ...r
}) => /* @__PURE__ */ t(er, {
  colorScheme: kd[`${o}`],
  ...r,
  children: e
}), ou = ({
  children: e,
  bodyClassName: o,
  bodyStyleProps: r,
  cardStyleProps: n,
  "data-testid": a,
  id: i,
  title: l,
  titleClassName: s,
  titleStyleProps: c,
  ...p
}) => {
  const d = A("Card");
  return /* @__PURE__ */ b(M, {
    __css: d.container,
    id: i,
    "data-testid": a,
    ...n,
    ...p,
    children: [l && /* @__PURE__ */ t(M, {
      __css: d.header,
      className: s,
      id: i && `${i}-title`,
      "data-testid": a && `${a}-title`,
      ...c,
      children: l
    }), /* @__PURE__ */ t(M, {
      __css: d.body,
      className: o,
      id: i && `${i}-body`,
      "data-testid": a && `${a}-body`,
      ...r,
      children: e
    })]
  });
}, I = ({
  __css: e,
  icon: o,
  size: r,
  ...n
}) => /* @__PURE__ */ t(ao, {
  __css: {
    fontSize: "inherit",
    ...e
  },
  as: bo,
  icon: o,
  ...r && {
    ...vt[r]
  },
  ...n
}), z = {
  arrowDown: {
    solid: ra,
    light: Ga
  },
  arrowLeft: {
    solid: na,
    light: Oa
  },
  arrowRight: {
    solid: aa,
    light: Va
  },
  arrowUp: {
    solid: ia,
    light: ja
  },
  atom: {
    solid: la,
    light: Ua
  },
  bell: {
    solid: sa,
    light: Ya
  },
  calendar: {
    solid: ca,
    light: qa
  },
  check: {
    solid: da,
    light: Xa
  },
  chevronDown: {
    solid: pa,
    light: Za
  },
  chevronLeft: {
    solid: ua,
    light: Ka
  },
  chevronRight: {
    solid: ba,
    light: Ja
  },
  chevronUp: {
    solid: ha,
    light: Qa
  },
  circle: {
    solid: ga,
    light: ei
  },
  circle0: {
    solid: ma,
    light: ti
  },
  circle1: {
    solid: fa,
    light: oi
  },
  circle2: {
    solid: ya,
    light: ri
  },
  circle3: {
    solid: xa,
    light: ni
  },
  circle4: {
    solid: Sa,
    light: ai
  },
  circle5: {
    solid: va,
    light: ii
  },
  circle6: {
    solid: Ca,
    light: li
  },
  circle7: {
    solid: wa,
    light: si
  },
  circle8: {
    solid: ka,
    light: ci
  },
  circle9: {
    solid: $a,
    light: di
  },
  circleCheck: {
    solid: _a,
    light: pi
  },
  circleDot: {
    solid: Ia,
    light: ui
  },
  circleInfo: {
    solid: za,
    light: bi
  },
  circleXmark: {
    solid: Ma,
    light: hi
  },
  cloudArrowUp: {
    solid: Da,
    light: gi
  },
  comment: {
    solid: Ba,
    light: mi
  },
  creditCard: {
    solid: Na,
    light: fi
  },
  creditCardFront: {
    solid: Pa,
    light: yi
  },
  dollarSign: {
    solid: Aa,
    light: xi
  },
  eye: {
    solid: Ta,
    light: Si
  },
  filter: {
    solid: Ra,
    light: vi
  },
  magnifyingGlass: {
    solid: Ea,
    light: Ci
  },
  minus: {
    solid: Fa,
    light: wi
  },
  plus: {
    solid: Wa,
    light: ki
  },
  triangleExclamation: {
    solid: Ha,
    light: $i
  },
  xmark: {
    solid: La,
    light: ho
  }
}, $d = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.arrowDown[`${e}`],
  ...o
}), Vt = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.arrowUp[`${e}`],
  ...o
}), _d = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.bell[`${e}`],
  ...o
}), Id = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.calendar[`${e}`],
  ...o
}), zd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.check[`${e}`],
  ...o
}), pe = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.chevronDown[`${e}`],
  ...o
}), fo = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.chevronLeft[`${e}`],
  ...o
}), yo = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.chevronRight[`${e}`],
  ...o
}), Md = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.chevronUp[`${e}`],
  ...o
}), Dd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle[`${e}`],
  ...o
}), Bd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle0[`${e}`],
  ...o
}), Nd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle1[`${e}`],
  ...o
}), Pd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle2[`${e}`],
  ...o
}), Ad = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle3[`${e}`],
  ...o
}), Td = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle4[`${e}`],
  ...o
}), Rd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle5[`${e}`],
  ...o
}), Ed = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle6[`${e}`],
  ...o
}), Fd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle7[`${e}`],
  ...o
}), Wd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle8[`${e}`],
  ...o
}), Hd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circle9[`${e}`],
  ...o
}), $t = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circleCheck[`${e}`],
  ...o
}), Ld = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circleDot[`${e}`],
  ...o
}), Gd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circleInfo[`${e}`],
  ...o
}), Ge = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.circleXmark[`${e}`],
  ...o
}), Od = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.cloudArrowUp[`${e}`],
  ...o
}), Vd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.comment[`${e}`],
  ...o
}), jd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.creditCard[`${e}`],
  ...o
}), Ud = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.creditCardFront[`${e}`],
  ...o
}), Yd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.dollarSign[`${e}`],
  ...o
}), qd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.eye[`${e}`],
  ...o
}), Xd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.filter[`${e}`],
  ...o
}), _t = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.magnifyingGlass[`${e}`],
  ...o
}), Zd = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.minus[`${e}`],
  ...o
}), xo = ({
  variant: e = "solid",
  ...o
}) => /* @__PURE__ */ t(I, {
  icon: z.triangleExclamation[`${e}`],
  ...o
}), ie = (e) => Wt.Children.toArray(e).filter(
  (o) => Wt.isValidElement(o)
), $e = (...e) => e.filter(Boolean).join(" "), So = ({
  children: e,
  className: o,
  ...r
}) => {
  const n = A("FormError", {});
  return /* @__PURE__ */ b(ne.div, {
    __css: n.text,
    className: $e("chakra-form__error-message", o),
    ...r,
    children: [/* @__PURE__ */ t(Ge, {
      variant: "solid",
      size: "xl",
      sx: n.icon
    }), /* @__PURE__ */ t(M, {
      children: e
    })]
  });
}, V = ({
  children: e,
  name: o,
  "data-testid": r,
  error: n,
  formHelperText: a,
  hideOptionalLabel: i = !1,
  id: l = o,
  isRequired: s,
  label: c,
  ...p
}) => /* @__PURE__ */ b(tr, {
  isInvalid: !!n,
  id: l,
  isRequired: s,
  "data-testid": r,
  ...p,
  children: [c && /* @__PURE__ */ b(or, {
    requiredIndicator: /* @__PURE__ */ t(j, {}),
    "data-testid": r && `${r}-label`,
    children: [c, " ", !s && !i && /* @__PURE__ */ t("span", {
      className: "label-optional",
      children: "(optional)"
    })]
  }), e, a && /* @__PURE__ */ t(rr, {
    "data-testid": r && `${r}-helptext`,
    children: a
  }), n && /* @__PURE__ */ t(So, {
    "data-testid": r && `${r}-error`,
    id: l ? `${l}-feedback` : void 0,
    children: n
  })]
}), vo = D((e, o) => {
  const {
    size: r = "md",
    children: n,
    ...a
  } = e;
  return /* @__PURE__ */ t(nr, {
    ref: o,
    size: r,
    ...a,
    children: n
  });
});
vo.displayName = "SwitchBase";
const It = D((e, o) => {
  const {
    name: r,
    error: n,
    hideOptionalLabel: a = !1,
    label: i,
    formHelperText: l,
    isReadOnly: s,
    isRequired: c,
    id: p = r,
    controlStyleProps: d,
    controlClassName: u,
    "data-testid": h,
    ...g
  } = e;
  return /* @__PURE__ */ t(V, {
    name: r,
    id: p,
    error: n,
    hideOptionalLabel: a,
    label: i,
    formHelperText: l,
    isReadOnly: s,
    isRequired: c,
    "data-testid": h && `${h}-control`,
    className: u,
    ...d,
    children: /* @__PURE__ */ t(vo, {
      ref: o,
      name: r,
      "data-testid": h,
      ...g
    })
  });
});
It.displayName = "Switch";
const Kd = ({
  children: e,
  isLoaded: o = !1,
  ...r
}) => /* @__PURE__ */ t(ar, {
  isLoaded: o,
  ...r,
  children: e
}), $ = ({
  children: e,
  variant: o = "body",
  type: r = "primary",
  ...n
}) => {
  const a = A("Typography", {
    variant: o
  }), i = ir();
  let l;
  switch (r) {
    case "secondary":
      l = i.colors.gray[600];
      break;
    case "error":
      l = i.colors.red[500];
      break;
    case "link":
      l = i.colors.teal[500];
      break;
    case "primary":
    default:
      l = i.color;
      break;
  }
  return /* @__PURE__ */ t(ne.p, {
    __css: a,
    color: l,
    ...n,
    children: e
  });
}, Y = D((e, o) => {
  const {
    children: r,
    isDestructive: n = !1,
    isFullWidth: a,
    ...i
  } = e;
  return /* @__PURE__ */ t(lr, {
    ref: o,
    colorScheme: n ? "red" : void 0,
    w: a ? "100%" : void 0,
    ...i,
    children: r
  });
});
Y.displayName = "Button";
const O = D((e, o) => {
  const {
    isFullWidth: r,
    ...n
  } = e;
  return /* @__PURE__ */ t(sr, {
    ref: o,
    w: r ? "100%" : void 0,
    ...n
  });
});
O.displayName = "IconButton";
const Jd = D((e, o) => {
  const {
    children: r,
    spacing: n = 3,
    ...a
  } = e;
  return /* @__PURE__ */ t(cr, {
    ref: o,
    spacing: n,
    ...a,
    children: r
  });
});
Jd.displayName = "ButtonGroup";
const Qd = ({
  allColumns: e
}) => /* @__PURE__ */ b(bt, {
  children: [/* @__PURE__ */ t(ht, {
    children: /* @__PURE__ */ t(Y, {
      variant: "tertiary",
      size: "sm",
      rightIcon: /* @__PURE__ */ t(pe, {
        size: "sm",
        variant: "light"
      }),
      children: "Columns"
    })
  }), /* @__PURE__ */ t(gt, {
    children: /* @__PURE__ */ t(mt, {
      children: /* @__PURE__ */ t(J, {
        children: e.filter((o) => {
          var r, n;
          return (n = (r = o.columnDef.meta) == null ? void 0 : r.isToggleable) != null ? n : !0;
        }).map((o) => {
          var r, n;
          return /* @__PURE__ */ b(P, {
            gap: 2,
            children: [/* @__PURE__ */ t(M, {
              children: /* @__PURE__ */ t(It, {
                size: "sm",
                isChecked: o.getIsVisible(),
                onChange: o.getToggleVisibilityHandler(),
                name: o.id
              })
            }), /* @__PURE__ */ t($, {
              variant: "bodySmall",
              children: (n = (r = o.columnDef.meta) == null ? void 0 : r.columnName) != null ? n : o.id
            })]
          }, o.id);
        })
      })
    })
  })]
}), Ne = ({
  children: e,
  isNumeric: o,
  colSpan: r,
  ...n
}) => /* @__PURE__ */ t(dr, {
  colSpan: r,
  isNumeric: o,
  ...n,
  children: e
}), ye = ({
  children: e,
  ...o
}) => /* @__PURE__ */ t(pr, {
  ...o,
  children: e
}), tt = ({
  addOn: e,
  content: o,
  heading: r,
  icon: n
}) => /* @__PURE__ */ b(E, {
  spacing: 4,
  children: [n, /* @__PURE__ */ b(E, {
    spacing: 1,
    children: [/* @__PURE__ */ t($, {
      variant: "subheading2",
      children: r
    }), /* @__PURE__ */ t($, {
      children: o
    })]
  }), e]
}), e0 = ({
  colSpan: e = 1,
  addOn: o,
  error: r,
  searchTerm: n
}) => /* @__PURE__ */ t(ye, {
  children: /* @__PURE__ */ t(Ne, {
    colSpan: e,
    p: "0",
    children: /* @__PURE__ */ t(xe, {
      bg: "gray.100",
      py: "46px",
      px: 6,
      children: r ? /* @__PURE__ */ t(tt, {
        addOn: o,
        icon: /* @__PURE__ */ t(xo, {
          size: "4xl",
          color: "red.500",
          variant: "light"
        }),
        heading: "Something went wrong!",
        content: "Please try again later."
      }) : n ? /* @__PURE__ */ t(tt, {
        addOn: o,
        icon: /* @__PURE__ */ t(Xd, {
          size: "4xl",
          variant: "light"
        }),
        heading: `No results for "${n}" found!`,
        content: "Broaden your filter settings or try searching for something else."
      }) : /* @__PURE__ */ t(tt, {
        addOn: o,
        icon: /* @__PURE__ */ t(_t, {
          size: "4xl",
          variant: "light"
        }),
        heading: "No data yet!",
        content: "Try searching or adding new content."
      })
    })
  })
}), Co = D(({
  children: e,
  isNumeric: o,
  colSpan: r,
  title: n,
  ...a
}, i) => /* @__PURE__ */ t(ur, {
  ref: i,
  colSpan: r,
  title: n,
  isNumeric: o,
  ...a,
  children: e
}));
Co.displayName = "Th";
const t0 = (e, o, r) => (r.splice(r.indexOf(o), 0, r.splice(r.indexOf(e), 1)[0]), [...r]), o0 = ({
  header: e,
  table: o,
  canReorderColumns: r,
  canSortColumns: n
}) => {
  var g, f, m, y;
  const {
    getState: a,
    setColumnOrder: i
  } = o, {
    columnOrder: l
  } = a(), {
    column: s
  } = e, [, c] = Ai({
    accept: "column",
    drop: (x) => {
      const _ = t0(x.id, s.id, l);
      i(_);
    }
  }), [{
    isDragging: p
  }, d, u] = Ti({
    collect: (x) => ({
      isDragging: x.isDragging()
    }),
    item: () => s,
    type: "column",
    canDrag: () => {
      var x, _;
      return r && ((_ = (x = e.column.columnDef.meta) == null ? void 0 : x.isReorderable) != null ? _ : !0);
    }
  }), {
    isNumeric: h
  } = (g = e.column.columnDef.meta) != null ? g : {};
  return /* @__PURE__ */ t(Co, {
    ref: (x) => {
      c(x), d(x), u(x);
    },
    colSpan: e.colSpan,
    isNumeric: h,
    width: e.getSize() !== 0 ? `${e.getSize()}px` : void 0,
    opacity: p ? 0.5 : 1,
    children: e.isPlaceholder ? null : /* @__PURE__ */ b(P, {
      _hover: e.column.getIsSorted() ? {} : {
        svg: {
          opacity: 0.4
        }
      },
      gap: 1,
      alignItems: "center",
      justifyContent: h ? "flex-end" : "flex-start",
      ...n && e.column.getCanSort() ? {
        cursor: "pointer",
        userSelect: "none",
        onClick: () => {
          const _ = a().sorting.find((w) => w.id === s.id);
          _ ? _.desc ? e.column.clearSorting() : e.column.toggleSorting(!0, e.column.getCanMultiSort()) : e.column.toggleSorting(!1, e.column.getCanMultiSort());
        }
      } : r && ((m = (f = e.column.columnDef.meta) == null ? void 0 : f.isReorderable) != null ? m : !0) ? {
        cursor: "grab",
        userSelect: "none"
      } : {},
      children: [De(e.column.columnDef.header, e.getContext()), (y = n && e.column.getCanSort() && {
        asc: /* @__PURE__ */ t(Vt, {
          size: "md",
          variant: "solid"
        }),
        desc: /* @__PURE__ */ t($d, {
          size: "md",
          variant: "solid"
        })
      }[e.column.getIsSorted()]) != null ? y : /* @__PURE__ */ t(Vt, {
        size: "md",
        opacity: 0
      })]
    })
  }, e.id);
}, r0 = ({
  children: e
}) => /* @__PURE__ */ b(bt, {
  children: [/* @__PURE__ */ t(ht, {
    children: /* @__PURE__ */ t(Y, {
      width: {
        base: "100%",
        md: "auto"
      },
      variant: "tertiary",
      size: "sm",
      rightIcon: /* @__PURE__ */ t(pe, {
        size: "sm",
        variant: "light"
      }),
      children: "Filter"
    })
  }), /* @__PURE__ */ t(gt, {
    children: /* @__PURE__ */ t(mt, {
      children: e
    })
  })]
}), n0 = ({
  children: e,
  ...o
}) => /* @__PURE__ */ t(br, {
  ...o,
  children: e
}), a0 = hr`
    from {
        opacity: 0%;
        transform: translate(0, -5px)
    }

    to {
        opacity: unset;
        transform: none;
    }
`, i0 = ({
  children: e
}) => {
  const o = gr();
  return /* @__PURE__ */ t(M, {
    overflow: "hidden",
    children: /* @__PURE__ */ t(M, {
      animation: o ? void 0 : `${a0} 0.2s ease-in`,
      children: e
    })
  });
}, l0 = ({
  onClick: e
}) => /* @__PURE__ */ t(O, {
  onClick: e,
  borderLeftRadius: "none",
  "aria-label": "Search",
  className: "search-input-button",
  icon: /* @__PURE__ */ t(_t, {
    variant: "light"
  })
}), zt = D((e, o) => {
  const {
    inputLeftAddon: r,
    inputRightAddon: n,
    inputLeftElement: a,
    inputLeftElementOverride: i,
    inputRightElement: l,
    inputRightElementOverride: s,
    maxW: c,
    maxWidth: p,
    minW: d,
    minWidth: u,
    onSearchClick: h,
    size: g = "md",
    showSearchButton: f = !1,
    type: m,
    variant: y = "outline",
    w: x,
    width: _,
    ...w
  } = e;
  return /* @__PURE__ */ b(mr, {
    size: g,
    variant: y,
    w: x,
    width: _,
    maxW: c,
    maxWidth: p,
    minW: d,
    minWidth: u,
    children: [a && !i && /* @__PURE__ */ t(io, {
      pointerEvents: "none",
      children: a
    }), i, r && /* @__PURE__ */ t(fr, {
      children: r
    }), r && y === "filled" && /* @__PURE__ */ t(nt, {
      orientation: "vertical",
      marginLeft: "-1px"
    }), /* @__PURE__ */ t(yr, {
      ref: o,
      type: m,
      ...w
    }), l && !s && /* @__PURE__ */ t(ft, {
      pointerEvents: "none",
      children: l
    }), s, n && y === "filled" && /* @__PURE__ */ t(nt, {
      orientation: "vertical",
      marginRight: "1px"
    }), n && /* @__PURE__ */ t(xr, {
      children: n
    }), m === "search" && f && /* @__PURE__ */ t(l0, {
      onClick: h
    })]
  });
});
zt.displayName = "InputBase";
const Ee = D((e, o) => {
  const {
    name: r,
    controlStyleProps: n,
    controlClassName: a,
    "data-testid": i,
    error: l,
    formHelperText: s,
    hideOptionalLabel: c = !1,
    id: p = r,
    isDisabled: d,
    isReadOnly: u,
    isRequired: h,
    label: g,
    variant: f,
    ...m
  } = e;
  return /* @__PURE__ */ t(V, {
    name: r,
    hideOptionalLabel: c,
    id: p,
    error: l,
    label: g,
    isDisabled: d,
    isReadOnly: u,
    isRequired: h,
    formHelperText: s,
    "data-testid": i && `${i}-control`,
    className: a,
    ...n,
    children: /* @__PURE__ */ t(zt, {
      ref: o,
      name: r,
      "data-testid": i,
      variant: u ? "filled" : f,
      ...m
    })
  });
});
Ee.displayName = "Input";
const s0 = ({
  isSearchBtnDisplayed: e,
  onClick: o
}) => /* @__PURE__ */ t(ft, {
  className: e ? "input-clear-element search-button-repos" : "input-clear-element",
  children: /* @__PURE__ */ t(O, {
    variant: "ghost",
    "aria-label": "Clear field",
    onClick: o,
    icon: /* @__PURE__ */ t(Ge, {
      variant: "solid"
    })
  })
}), Mt = D((e, o) => {
  const {
    onSearch: r,
    className: n,
    hasButton: a,
    onChange: i,
    onClear: l,
    placeholder: s = "Search...",
    size: c = "md",
    wait: p = 300,
    ...d
  } = e, u = ue(null), h = o || u, [g, f] = L(!1), m = Fi(r, p), y = $e(a ? "search-input-with-button" : "search-input-no-button", n), x = (k) => {
    f(k !== "");
  }, _ = (k) => {
    l == null || l(), k != null && k.current && (k.current.value = "", k.current.focus()), f(!1);
  }, w = (k) => {
    var T;
    k.current && r((T = k.current) == null ? void 0 : T.value);
  };
  return /* @__PURE__ */ t(Ee, {
    ref: h,
    type: "search",
    className: y,
    placeholder: s,
    size: c,
    variant: "outline",
    inputLeftElementOverride: a ? void 0 : /* @__PURE__ */ t(io, {
      pointerEvents: "none",
      className: "search-input-left-element-icon",
      children: /* @__PURE__ */ t(_t, {
        variant: "light"
      })
    }),
    inputRightElementOverride: g ? /* @__PURE__ */ t(s0, {
      isSearchBtnDisplayed: a,
      onClick: () => {
        _(h), !a && m("");
      }
    }) : void 0,
    showSearchButton: !!a,
    onChange: (k) => {
      i == null || i(k), x(k.target.value), !a && m(k.target.value);
    },
    onSearchClick: a ? () => w(h) : void 0,
    ...d
  });
});
Mt.displayName = "SearchInput";
const c0 = ({
  children: e,
  onSearch: o
}) => /* @__PURE__ */ b(P, {
  gap: {
    base: 2,
    md: 4
  },
  alignItems: {
    base: "flex-start",
    md: "center"
  },
  flexDirection: {
    base: "column",
    md: "row"
  },
  justifyContent: "space-between",
  pt: {
    base: 4,
    md: 0
  },
  px: {
    base: 4,
    md: 0
  },
  children: [o ? /* @__PURE__ */ t(Mt, {
    size: "sm",
    width: {
      base: "100%",
      md: "300px"
    },
    name: "search",
    onSearch: o
  }) : /* @__PURE__ */ t("div", {}), /* @__PURE__ */ t(P, {
    justifyContent: "flex-end",
    mb: {
      base: 4,
      md: 0
    },
    width: "100%",
    gap: {
      base: 2,
      md: 3
    },
    children: e
  })]
}), ke = D((e, o) => {
  const {
    name: r,
    id: n = r,
    hideOptionalLabel: a = !1,
    error: i,
    label: l,
    formHelperText: s,
    isReadOnly: c,
    isRequired: p,
    options: d,
    placeholder: u,
    controlStyleProps: h,
    controlClassName: g,
    children: f,
    variant: m = "outline",
    "data-testid": y,
    ...x
  } = e;
  return /* @__PURE__ */ t(V, {
    name: r,
    hideOptionalLabel: a,
    id: n,
    "data-testid": y && `${y}-control`,
    error: i,
    label: l,
    isReadOnly: c,
    isRequired: p,
    formHelperText: s,
    className: g,
    ...h,
    children: /* @__PURE__ */ t(Sr, {
      placeholder: u,
      name: r,
      "data-testid": y,
      ref: o,
      variant: c ? "filled" : m,
      icon: /* @__PURE__ */ t(pe, {
        variant: "light"
      }),
      ...x,
      children: d ? d.map(({
        disabled: _,
        key: w,
        label: k,
        value: T
      }) => /* @__PURE__ */ t("option", {
        disabled: _,
        value: T,
        children: k
      }, w != null ? w : T)) : f
    })
  });
});
ke.displayName = "Select";
const d0 = () => /* @__PURE__ */ t(O, {
  as: "div",
  variant: "ghost",
  size: "sm",
  "aria-label": "",
  icon: /* @__PURE__ */ t(yo, {
    fontSize: {
      base: S.sm,
      md: S.md
    },
    variant: "light"
  })
}), p0 = () => /* @__PURE__ */ t(O, {
  as: "div",
  variant: "ghost",
  size: "sm",
  "aria-label": "",
  icon: /* @__PURE__ */ t(fo, {
    fontSize: {
      base: S.sm,
      md: S.md
    },
    variant: "light"
  })
}), u0 = ({
  className: e,
  testId: o,
  ...r
}) => /* @__PURE__ */ t(M, {
  "data-testid": o,
  children: /* @__PURE__ */ t(Wi, {
    containerClassName: e,
    ...r
  })
}), b0 = ne(u0, {
  shouldForwardProp: () => !0
}), h0 = ({
  itemsCount: e,
  itemsPerPage: o = 10,
  marginPagesDisplayed: r = 1,
  onPageClick: n,
  pageCount: a,
  pageRangeDisplayed: i = 3,
  testId: l,
  ...s
}) => {
  const c = A("Pagination"), [p, d] = L(0);
  U(() => {
    e && d(Math.ceil(e / o));
  }, [e, o]);
  const u = (h) => {
    const g = h.selected * o % e;
    n == null || n({
      ...h,
      offset: g
    });
  };
  return /* @__PURE__ */ t(b0, {
    sx: c.container,
    breakLabel: "...",
    nextLabel: /* @__PURE__ */ t(d0, {}),
    previousLabel: /* @__PURE__ */ t(p0, {}),
    onPageChange: u,
    pageRangeDisplayed: i,
    pageCount: a != null ? a : p,
    marginPagesDisplayed: r,
    testId: l,
    ...s
  });
}, g0 = ({
  id: e,
  pageSize: o,
  onPageSizeChange: r,
  pageSizeOptions: n = [10, 25, 50, 100],
  totalCount: a,
  currentPage: i,
  isManual: l,
  pageCount: s,
  onPageClick: c
}) => {
  const p = G(() => l ? Math.ceil(a / o) : s, [l, o, a, s]), d = G(() => i && o && i * o, [i, o]), u = G(() => i * o + o, [i, o]);
  return /* @__PURE__ */ b(P, {
    gap: 2,
    flexDirection: {
      base: "column",
      md: "row"
    },
    justifyContent: "space-between",
    py: 3,
    px: 6,
    children: [/* @__PURE__ */ b(P, {
      alignItems: "center",
      justifyContent: {
        base: "space-between",
        md: "flex-start"
      },
      gap: 2,
      children: [/* @__PURE__ */ t($, {
        variant: "bodySmall",
        children: "Show rows per page:"
      }), /* @__PURE__ */ t(M, {
        maxW: "100px",
        children: /* @__PURE__ */ t(ke, {
          size: "sm",
          value: o.toString(),
          onChange: ({
            currentTarget: h
          }) => {
            r == null || r(Number(h.value));
          },
          options: n.map((h) => ({
            label: h.toString(),
            value: h.toString()
          })),
          "aria-label": "Select page size",
          name: `${wo}--pageSize-${e}`
        })
      })]
    }), /* @__PURE__ */ b(P, {
      gap: 6,
      justifyContent: {
        base: "space-between",
        md: "flex-start"
      },
      alignItems: "center",
      children: [/* @__PURE__ */ b($, {
        variant: "bodySmall",
        children: [`${d + 1}-${u > a ? a : u}`, " ", /* @__PURE__ */ b(M, {
          as: "span",
          color: "gray.600",
          children: ["of ", a]
        })]
      }), p > 1 && /* @__PURE__ */ t(h0, {
        itemsCount: a,
        itemsPerPage: o,
        pageCount: p,
        onPageClick: ({
          selected: h
        }) => c == null ? void 0 : c(h),
        renderOnZeroPageCount: () => null,
        forcePage: i
      })]
    })]
  });
}, m0 = ({
  children: e
}) => /* @__PURE__ */ t(vr, {
  children: e
}), f0 = (e) => /* @__PURE__ */ t(Cr, {
  ...e
}), wo = "gravity-table", ru = ({
  actions: e,
  columns: o,
  columnsControl: r = !1,
  columnOrder: n,
  columnVisibility: a,
  data: i,
  debugAll: l,
  debugColumns: s,
  debugHeaders: c,
  debugRows: p,
  debugTable: d,
  dndContext: u,
  emptyStateAddon: h,
  enableMultiSort: g = !1,
  error: f,
  expanded: m,
  getRowAccessibilityName: y,
  getRowCanExpand: x,
  getSubRows: _,
  id: w,
  isLoading: k = !1,
  onColumnOrderChange: T,
  onColumnVisibilityChange: F,
  onExpandedChange: be,
  onPageChange: Ve,
  onPageSizeChange: Ho,
  onRowSelectionChange: K,
  onSearch: Dt,
  onSortingChange: je,
  pageCount: Ue,
  pageIndex: Ye = 0,
  pageSize: he = 10,
  renderEmptyState: Bt,
  renderFilterComponent: qe,
  renderSubComponent: ee,
  rowSelection: W,
  searchTerm: Lo,
  selectedActions: le,
  selectedLabel: Nt = (Xe) => `Selected items: ${Xe.length}`,
  sorting: Go,
  totalCount: se,
  ...Oo
}) => {
  const Xe = ta(), Pt = w || Xe, [At, Tt] = L({}), Vo = G(() => m || At, [m, At]), jo = G(() => be || Tt, [be, Tt]), [ge, Uo] = L(!1), H = ae({
    base: !0,
    md: !1
  }, {
    fallback: "md"
  }), Yo = G(() => H ? o.reduce((B, v, ce) => (ce > 0 && v.id && (B[v.id] = !1), B), {}) : a, [a, H, o]), qo = G(() => ({
    pageIndex: Ye,
    pageSize: he
  }), [Ye, he]), Rt = G(() => {
    let B = o;
    return H && o.map((v, ce) => (ce > 0 && (v.meta = v.meta || {}), v)), (ee && !H || H && !ge) && (B = [...B, {
      id: "expand",
      size: 16,
      enableSorting: !1,
      meta: {
        isReorderable: !1,
        isToggleable: !1
      },
      header: ({
        table: v
      }) => /* @__PURE__ */ t(O, {
        onClick: v.getToggleAllRowsExpandedHandler(),
        "aria-label": "expand all rows",
        variant: "ghost",
        size: "sm",
        icon: /* @__PURE__ */ t(pe, {
          variant: "light",
          size: "md",
          rotation: v.getIsAllRowsExpanded() ? 180 : void 0,
          style: {
            transition: "transform .2s ease"
          }
        })
      }),
      cell: ({
        row: v
      }) => /* @__PURE__ */ t(j, {
        children: v.getCanExpand() || H ? /* @__PURE__ */ t(O, {
          onClick: v.getToggleExpandedHandler(),
          "aria-label": `Expand row for ${y ? y(v) : v.id}`,
          variant: "ghost",
          size: "sm",
          icon: /* @__PURE__ */ t(pe, {
            variant: "light",
            size: "md",
            rotation: v.getIsExpanded() ? 180 : void 0,
            style: {
              transition: "transform .2s ease"
            }
          })
        }) : ee ? null : ""
      })
    }]), K && (!H || ge) && (B = [{
      id: "select",
      size: 16,
      enableSorting: !1,
      meta: {
        isReorderable: !1,
        isToggleable: !1
      },
      header: ({
        table: v
      }) => /* @__PURE__ */ t(P, {
        alignItems: "center",
        children: /* @__PURE__ */ t(Pe, {
          "aria-label": "Select all rows",
          size: "sm",
          isChecked: v.getIsAllRowsSelected(),
          isIndeterminate: v.getIsSomeRowsSelected(),
          onChange: v.getToggleAllRowsSelectedHandler()
        })
      }),
      cell: ({
        row: v
      }) => /* @__PURE__ */ t(P, {
        alignItems: "center",
        children: /* @__PURE__ */ t(Pe, {
          "aria-label": `Select ${y ? y(v) : v.id} row`,
          size: "sm",
          isChecked: v.getIsSelected(),
          isIndeterminate: v.getIsSomeSelected(),
          onChange: v.getToggleSelectedHandler()
        })
      })
    }, ...B]), k && (B = B.map((v) => ({
      ...v,
      cell: () => /* @__PURE__ */ t(M, {
        py: 2,
        children: /* @__PURE__ */ t(Kd, {
          width: "100%",
          height: 3.5
        })
      })
    }))), B;
  }, [o, K, k, y, H, ge]);
  U(() => {
    if (T) {
      let B = n != null ? n : [];
      (be || ee || H) && (B = [...B, "expand"]), K && (B = ["select", ...B]), T(B);
    }
  }, []);
  const Xo = G(() => k ? new Array(he).fill({}) : i != null ? i : [], [k, i, he]), te = _i({
    data: Xo,
    columns: Rt,
    defaultColumn: {
      minSize: 0,
      size: 0
    },
    state: {
      rowSelection: W,
      pagination: qo,
      expanded: Vo,
      sorting: Go,
      columnVisibility: Yo,
      columnOrder: n
    },
    onColumnOrderChange: T,
    onSortingChange: je,
    onExpandedChange: jo,
    getSubRows: _,
    manualPagination: !!Ve,
    onRowSelectionChange: K,
    getCoreRowModel: Ii(),
    getExpandedRowModel: zi(),
    getSortedRowModel: Mi(),
    debugAll: l,
    debugColumns: s,
    debugHeaders: c,
    debugRows: p,
    debugTable: d,
    manualSorting: !!je,
    enableMultiSort: g,
    getRowCanExpand: H ? () => !0 : x,
    manualExpanding: !!ee,
    onColumnVisibilityChange: F
  }), Et = !!Ve && (se != null ? se : 0) > 0, me = W || r || qe || Dt || e, Zo = !!T, Ko = !!je;
  return U(() => {
    K == null || K({});
  }, [ge]), /* @__PURE__ */ t(Ri, {
    backend: Ei,
    context: u != null ? u : window,
    children: /* @__PURE__ */ b(M, {
      position: "relative",
      border: "1px solid",
      borderColor: "gray.200",
      borderRadius: "lg",
      children: [me && /* @__PURE__ */ t(M, {
        px: {
          base: 0,
          md: 6
        },
        py: {
          base: 0,
          md: 5
        },
        children: /* @__PURE__ */ t(Di, {
          children: /* @__PURE__ */ b(Bi, {
            features: Ni,
            children: [W && !!Object.keys(W).length && /* @__PURE__ */ b(j, {
              children: [/* @__PURE__ */ b(P, {
                display: {
                  base: "none",
                  md: "flex"
                },
                zIndex: "banner",
                borderRadius: "lg",
                backgroundColor: "gray.100",
                width: {
                  base: "100%",
                  md: "calc(100% - 48px)"
                },
                position: "absolute",
                as: Ze.div,
                direction: {
                  base: "column",
                  md: "row"
                },
                justifyContent: "space-between",
                alignItems: {
                  md: "center"
                },
                px: 3,
                py: 2,
                gap: 2,
                initial: {
                  y: "-24px",
                  opacity: 0
                },
                animate: {
                  y: -8,
                  opacity: 1,
                  transition: {
                    type: "spring",
                    stiffness: 700,
                    damping: 30
                  }
                },
                exit: {
                  y: "-16px",
                  opacity: 0
                },
                children: [/* @__PURE__ */ t($, {
                  as: "span",
                  variant: "bodyBoldSmall",
                  children: Nt(Object.keys(W))
                }), le == null ? void 0 : le(Object.keys(W))]
              }), /* @__PURE__ */ b(P, {
                display: {
                  base: "flex",
                  md: "none"
                },
                zIndex: "banner",
                borderRadius: "lg",
                backgroundColor: "gray.100",
                width: {
                  base: "100%",
                  md: "calc(100% - 48px)"
                },
                position: "absolute",
                as: Ze.div,
                direction: {
                  base: "column",
                  md: "row"
                },
                justifyContent: "space-between",
                alignItems: {
                  md: "center"
                },
                px: 3,
                py: 2,
                gap: 2,
                initial: {
                  y: "-24px",
                  opacity: 0
                },
                animate: {
                  y: 0,
                  opacity: 1,
                  transition: {
                    type: "spring",
                    stiffness: 700,
                    damping: 30
                  }
                },
                exit: {
                  y: "-16px",
                  opacity: 0
                },
                children: [/* @__PURE__ */ t($, {
                  as: "span",
                  variant: "bodyBoldSmall",
                  children: Nt(Object.keys(W))
                }), le == null ? void 0 : le(Object.keys(W))]
              })]
            }), me && /* @__PURE__ */ b(j, {
              children: [/* @__PURE__ */ t(Ze.div, {
                animate: {
                  y: Object.keys(W != null ? W : {}).length ? 20 : 0,
                  opacity: Object.keys(W != null ? W : {}).length ? 0 : 1,
                  transition: {
                    type: "spring",
                    stiffness: 700,
                    damping: 30
                  }
                },
                children: /* @__PURE__ */ b(c0, {
                  onSearch: Dt,
                  children: [qe && /* @__PURE__ */ t(r0, {
                    children: qe
                  }), r && !H && /* @__PURE__ */ t(Qd, {
                    allColumns: te.getAllLeafColumns()
                  }), e]
                })
              }), H && K && /* @__PURE__ */ t(It, {
                mb: 4,
                px: {
                  base: 4,
                  md: 0
                },
                name: "select-rows",
                onChange: (B) => Uo(B.target.checked),
                isChecked: ge,
                children: "Select Row(s)"
              })]
            })]
          })
        })
      }), /* @__PURE__ */ t(n0, {
        children: /* @__PURE__ */ b(wr, {
          width: "100%",
          minWidth: `${te.getTotalSize()}px`,
          id: `${wo}-${Pt}`,
          ...Oo,
          children: [/* @__PURE__ */ t(f0, {
            children: te.getHeaderGroups().map((B) => /* @__PURE__ */ t(ye, {
              sx: {
                "> th:first-of-type": {
                  ...me ? {} : {
                    borderTopLeftRadius: "8px"
                  }
                },
                "> th:last-child": {
                  ...me ? {} : {
                    borderTopRightRadius: "8px"
                  }
                },
                "> th": {
                  ...me ? {} : {
                    borderTop: "none"
                  }
                }
              },
              children: B.headers.map((v) => /* @__PURE__ */ t(o0, {
                canReorderColumns: Zo,
                header: v,
                table: te,
                canSortColumns: Ko
              }, v.id))
            }, B.id))
          }), /* @__PURE__ */ t(m0, {
            children: te.getRowModel().rows.length === 0 ? Bt ? /* @__PURE__ */ t(ye, {
              children: /* @__PURE__ */ t(Ne, {
                colSpan: te.getHeaderGroups()[0].headers.length,
                children: Bt
              })
            }) : /* @__PURE__ */ t(e0, {
              colSpan: Rt.length,
              searchTerm: Lo,
              error: f,
              addOn: h
            }) : te.getRowModel().rows.map((B) => /* @__PURE__ */ b(oa, {
              children: [/* @__PURE__ */ t(ye, {
                _last: Et ? {} : {
                  "> td": {
                    borderBottom: "none"
                  }
                },
                children: B.getVisibleCells().map((v) => {
                  var ce;
                  return /* @__PURE__ */ t(Ne, {
                    width: v.column.getSize() !== 0 ? `${v.column.getSize()}px` : void 0,
                    isNumeric: (ce = v.column.columnDef.meta) == null ? void 0 : ce.isNumeric,
                    children: De(v.column.columnDef.cell, v.getContext())
                  }, v.id);
                })
              }), B.getIsExpanded() && (H || ee) && /* @__PURE__ */ t(ye, {
                "data-table-row-expander": !0,
                children: /* @__PURE__ */ b(Ne, {
                  p: 0,
                  colSpan: B.getVisibleCells().length,
                  children: [H && /* @__PURE__ */ t(J, {
                    spacing: "0",
                    children: B.getAllCells().filter((v) => !v.column.getIsVisible()).map((v) => /* @__PURE__ */ b(Fe, {
                      justifyContent: "space-between",
                      px: 4,
                      py: 3,
                      spacing: 4,
                      children: [/* @__PURE__ */ t($, {
                        variant: "bodyBoldSmall",
                        children: De(
                          v.column.columnDef.header,
                          v.getContext()
                        )
                      }), /* @__PURE__ */ t($, {
                        variant: "bodySmall",
                        children: De(v.column.columnDef.cell, v.getContext())
                      })]
                    }, `${B.id}-${v.id}`))
                  }), ee && /* @__PURE__ */ t(i0, {
                    children: ee({
                      row: B
                    })
                  })]
                })
              })]
            }, B.id))
          })]
        })
      }), Et && /* @__PURE__ */ t(g0, {
        id: Pt,
        pageSize: he,
        totalCount: se != null ? se : 0,
        onPageSizeChange: Ho,
        pageCount: Ue != null ? Ue : 0,
        currentPage: Ye,
        onPageClick: Ve
      })]
    })
  });
}, nu = ({
  children: e,
  onCloseClick: o,
  showCloseButton: r = !1,
  ...n
}) => {
  const a = A("Tag");
  return /* @__PURE__ */ b(kr, {
    colorScheme: r ? "gray" : "teal",
    ...n,
    children: [/* @__PURE__ */ t($r, {
      children: e
    }), r && /* @__PURE__ */ t(O, {
      "aria-label": "Close tag",
      sx: a.closeButton,
      variant: "ghost",
      icon: /* @__PURE__ */ t(bo, {
        icon: ho,
        size: "xs",
        viewBox: "0 100 320 320"
      }),
      onClick: o
    })]
  });
}, y0 = ({
  data: e,
  allowMultiple: o = !0,
  defaultIndex: r,
  ...n
}) => (o || (r = 0), e.length > 0 ? /* @__PURE__ */ t(_r, {
  allowMultiple: o,
  defaultIndex: r,
  ...n,
  children: e.map((a) => /* @__PURE__ */ t(Ir, {
    children: ({
      isExpanded: i
    }) => /* @__PURE__ */ b(j, {
      children: [/* @__PURE__ */ t("h4", {
        children: /* @__PURE__ */ b(zr, {
          children: [/* @__PURE__ */ t(M, {
            flex: "1",
            textAlign: "left",
            children: a.title
          }), i ? /* @__PURE__ */ t(Md, {
            size: "md",
            variant: "light"
          }) : /* @__PURE__ */ t(pe, {
            size: "md",
            variant: "light"
          })]
        })
      }), /* @__PURE__ */ t(Mr, {
        children: a.content
      })]
    })
  }, a.title))
}) : null);
y0.displayName = "Accordion";
const Me = (e, o) => {
  e && e.current && e.current.children[0].children[o].scrollIntoView({
    behavior: "smooth",
    inline: "center"
  });
}, au = ({
  data: e,
  defaultIndex: o,
  index: r,
  listStyleProps: n,
  onChange: a,
  panelStyleProps: i,
  tabStyleProps: l,
  ...s
}) => {
  const c = ue(null);
  U(() => {
    r ? Me(c, r) : o ? Me(c, o) : Me(c, 0);
  }, []);
  const p = (d) => {
    Me(c, d), a && a(d);
  };
  return e.length > 0 ? /* @__PURE__ */ b(Dr, {
    onChange: p,
    defaultIndex: o,
    index: r,
    ...s,
    children: [/* @__PURE__ */ t(ne.div, {
      className: "tabs-scrollable",
      ref: c,
      children: /* @__PURE__ */ t(Br, {
        ...n,
        children: e.map((d) => /* @__PURE__ */ t(Nr, {
          isDisabled: d.isDisabled,
          "data-testid": d.testId,
          ...l,
          children: d.tab
        }, `${d.tab}`))
      })
    }), /* @__PURE__ */ t(Pr, {
      children: e.map((d) => /* @__PURE__ */ t(Ar, {
        "data-testid": d.testId && `${d.testId}-panel`,
        ...i,
        children: d.content
      }, `${d.tab}-panel`))
    })]
  }) : null;
}, x0 = ({
  status: e,
  ...o
}) => {
  const r = Tr(), n = "solid";
  switch (e) {
    case "error":
      return /* @__PURE__ */ t(Ge, {
        variant: n,
        __css: r.icon,
        color: "red.500",
        ...o
      });
    case "success":
      return /* @__PURE__ */ t($t, {
        variant: n,
        __css: r.icon,
        color: "green.500",
        ...o
      });
    case "warning":
      return /* @__PURE__ */ t(xo, {
        variant: n,
        __css: r.icon,
        color: "orange.500",
        ...o
      });
    case "info":
      return /* @__PURE__ */ t(Gd, {
        variant: n,
        __css: r.icon,
        color: "blue.500",
        ...o
      });
    default:
      return null;
  }
}, _e = ({
  alertStyleProps: e,
  children: o,
  descriptionStyleProps: r,
  iconStyleProps: n,
  id: a,
  onClose: i,
  showCloseButton: l = !0,
  status: s = "info",
  title: c,
  titleStyleProps: p,
  "data-testid": d,
  variant: u = "left-accent",
  ...h
}) => /* @__PURE__ */ b(Rr, {
  id: a,
  status: s,
  "data-testid": d,
  variant: u,
  addRole: u !== "toast",
  ...e,
  ...h,
  children: [/* @__PURE__ */ t(x0, {
    status: s,
    ...n
  }), /* @__PURE__ */ b(M, {
    children: [c && /* @__PURE__ */ t(Er, {
      id: a && `${a}-title`,
      "data-testid": d && `${d}-title`,
      ...p,
      children: c
    }), /* @__PURE__ */ t(Fr, {
      id: a && `${a}-desc`,
      "data-testid": d && `${d}-desc`,
      ...r,
      children: o
    })]
  }), l && /* @__PURE__ */ t(Wr, {
    alignSelf: "flex-start",
    position: "absolute",
    right: u === "toast" ? 1 : 4,
    top: u === "toast" ? 1 : 3,
    size: u === "toast" ? "sm" : {
      base: "sm",
      md: "md"
    },
    onClick: i
  })]
}), iu = (e) => /* @__PURE__ */ t(_e, {
  status: "info",
  ...e
}), lu = (e) => /* @__PURE__ */ t(_e, {
  status: "warning",
  ...e
}), su = (e) => /* @__PURE__ */ t(_e, {
  status: "success",
  ...e
}), cu = (e) => /* @__PURE__ */ t(_e, {
  status: "error",
  ...e
}), du = ({
  size: e = "md",
  ...o
}) => /* @__PURE__ */ t(Hr, {
  size: e,
  ...o
}), ko = ({
  className: e,
  size: o = "md",
  value: r = 0,
  variant: n = "normal",
  ...a
}) => (n === "error" && r === 0 && (e = $e("gravity-progress__appear-full", e)), /* @__PURE__ */ t(Lr, {
  size: o,
  value: r,
  variant: n,
  className: e,
  ...a
})), Oe = ({
  children: e,
  errorCode: o,
  errorDescription: r,
  actions: n,
  title: a,
  ...i
}) => {
  const l = A("ResponseError");
  return /* @__PURE__ */ b(M, {
    __css: l.container,
    ...i,
    children: [a && /* @__PURE__ */ t($, {
      variant: "h2",
      pb: {
        base: 3,
        md: 6
      },
      children: a
    }), e, /* @__PURE__ */ t($, {
      variant: "bodyBoldSmall",
      pt: {
        base: 3,
        md: 6
      },
      children: r
    }), /* @__PURE__ */ b($, {
      variant: "bodySmall",
      children: ["Error code: ", o]
    }), n && /* @__PURE__ */ t(M, {
      pt: {
        base: 3,
        md: 6
      },
      children: n
    })]
  });
}, pu = (e) => /* @__PURE__ */ t(Oe, {
  title: "Something went wrong!",
  errorCode: 500,
  errorDescription: "Internal Server Error",
  ...e,
  children: /* @__PURE__ */ b(E, {
    align: "stretch",
    spacing: {
      base: 3,
      md: 6
    },
    children: [/* @__PURE__ */ t($, {
      variant: "body",
      children: "An error has occurred and we're working to fix the problem!"
    }), /* @__PURE__ */ t($, {
      variant: "body",
      children: "Please try to refresh the page or try again at a later time. Thanks for your patience!"
    })]
  })
}), uu = (e) => /* @__PURE__ */ t(Oe, {
  title: "Something went wrong!",
  errorCode: 502,
  errorDescription: "Bad Gateway",
  ...e,
  children: /* @__PURE__ */ b(E, {
    align: "stretch",
    spacing: {
      base: 3,
      md: 6
    },
    children: [/* @__PURE__ */ t($, {
      variant: "body",
      children: "An error has occurred and we're working to fix the problem!"
    }), /* @__PURE__ */ t($, {
      variant: "body",
      children: "Please try to refresh the page or try again at a later time. Thanks for your patience!"
    })]
  })
}), bu = (e) => /* @__PURE__ */ t(Oe, {
  title: "We couldn't find this page!",
  errorCode: 404,
  errorDescription: "Not Found",
  ...e,
  children: /* @__PURE__ */ b(E, {
    align: "stretch",
    spacing: {
      base: 3,
      md: 6
    },
    children: [/* @__PURE__ */ t($, {
      variant: "body",
      children: "It looks like the page may not exist."
    }), /* @__PURE__ */ t($, {
      variant: "body",
      children: "Please check the URL and try again."
    })]
  })
}), hu = (e) => /* @__PURE__ */ t(Oe, {
  title: "No authorization found!",
  errorCode: 401,
  errorDescription: "Unauthorized",
  ...e,
  children: /* @__PURE__ */ b(E, {
    align: "stretch",
    spacing: {
      base: 3,
      md: 6
    },
    children: [/* @__PURE__ */ t($, {
      variant: "body",
      children: "This page is not publicly available."
    }), /* @__PURE__ */ t($, {
      variant: "body",
      children: "To access it, you may need to login first."
    })]
  })
}), gu = () => {
  const e = Gr(), o = ({
    description: l,
    duration: s = 5e3,
    position: c = "top-right",
    showCloseButton: p = !0,
    status: d = "info",
    ...u
  }) => {
    e({
      duration: s,
      position: c,
      render: ({
        id: h,
        onClose: g
      }) => /* @__PURE__ */ t(_e, {
        status: d,
        id: h ? `toast-${h}` : void 0,
        onClose: g,
        showCloseButton: p,
        variant: "toast",
        ...u,
        children: l
      })
    });
  };
  return {
    showToast: o,
    showInfoToast: (l) => {
      o({
        status: "info",
        ...l
      });
    },
    showWarningToast: (l) => {
      o({
        status: "warning",
        ...l
      });
    },
    showSuccessToast: (l) => {
      o({
        status: "success",
        ...l
      });
    },
    showErrorToast: (l) => {
      o({
        status: "error",
        ...l
      });
    }
  };
}, S0 = ({ minDate: e, maxDate: o, currentYear: r }) => {
  const n = [], a = e ? e.getFullYear() : r - 100, i = o ? o.getFullYear() : r + 25;
  for (let l = a; l <= i; l++)
    n.push(l);
  return n;
}, pt = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], v0 = pt.map((e) => ({
  label: e,
  value: e
})), C0 = ({
  date: e,
  decreaseMonth: o,
  increaseMonth: r,
  nextMonthButtonDisabled: n,
  prevMonthButtonDisabled: a,
  changeYear: i,
  changeMonth: l,
  minDate: s,
  maxDate: c,
  dataTestId: p
}) => {
  const d = G(() => S0({
    minDate: s,
    maxDate: c,
    currentYear: new Date().getFullYear()
  }).map((u) => ({
    label: u.toString(),
    value: u.toString()
  })), [s, c]);
  return /* @__PURE__ */ b(P, {
    alignItems: "center",
    gap: 1,
    justifyContent: "space-between",
    children: [/* @__PURE__ */ t(O, {
      size: "sm",
      "aria-label": "Previous month",
      icon: /* @__PURE__ */ t(fo, {
        variant: "light",
        size: "md"
      }),
      "data-testid": p ? `${p}-prev` : void 0,
      isDisabled: a,
      onClick: o,
      variant: "ghost"
    }), /* @__PURE__ */ t(ke, {
      textStyle: "bodyBold",
      width: "125px",
      variant: "filled",
      "data-testid": p ? `${p}-month` : void 0,
      size: "sm",
      name: "month",
      value: e ? pt[e.getMonth()] : "",
      onChange: ({
        target: {
          value: u
        }
      }) => l(pt.indexOf(u)),
      options: v0
    }), /* @__PURE__ */ t(ke, {
      textStyle: "bodyBold",
      variant: "filled",
      size: "sm",
      name: "year",
      "data-testid": p ? `${p}-year` : void 0,
      value: e ? `${e.getFullYear()}` : "",
      onChange: ({
        target: {
          value: u
        }
      }) => i(+u),
      options: d
    }), /* @__PURE__ */ t(O, {
      size: "sm",
      "aria-label": "Next month",
      icon: /* @__PURE__ */ t(yo, {
        variant: "light",
        size: "md"
      }),
      "data-testid": p ? `${p}-next` : void 0,
      isDisabled: n,
      onClick: r,
      variant: "ghost"
    })]
  });
};
function w0(e) {
  return e.format !== void 0 && e.mask !== void 0;
}
function k0(e) {
  return e.allowLeadingZeros !== void 0 || e.decimalScale !== void 0;
}
const Q = D((e, o) => {
  if (k0(e)) {
    const {
      decimalScale: r,
      onChange: n,
      allowLeadingZeros: a,
      ...i
    } = e;
    return /* @__PURE__ */ t(Li, {
      getInputRef: o,
      allowLeadingZeros: a,
      thousandSeparator: ",",
      decimalScale: r,
      onValueChange: n,
      customInput: Ee,
      ...i
    });
  } else if (w0(e)) {
    const {
      format: r,
      mask: n,
      onChange: a,
      ...i
    } = e;
    return /* @__PURE__ */ t(Gi, {
      getInputRef: o,
      format: r != null ? r : "",
      allowEmptyFormatting: !0,
      mask: n,
      onValueChange: a,
      customInput: Ee,
      ...i
    });
  } else
    return null;
});
Q.displayName = "MaskBase";
const $o = D((e, o) => /* @__PURE__ */ t(Q, {
  format: "####/##/##",
  mask: ["Y", "Y", "Y", "Y", "M", "M", "D", "D"],
  ...e,
  ref: o
}));
$o.displayName = "DateInput";
const _o = D(({
  onChange: e,
  onClick: o,
  onFocus: r,
  ...n
}, a) => /* @__PURE__ */ t($o, {
  ref: a,
  onChange: (i, l) => {
    if (l.event) {
      const {
        event: s
      } = l;
      s.currentTarget.value = i.formattedValue, e(l.event);
    }
  },
  onFocus: r,
  onClick: o,
  width: "100%",
  inputRightElement: /* @__PURE__ */ t(Id, {
    color: "teal.500",
    size: "md",
    variant: "light"
  }),
  ...n
}));
_o.displayName = "CustomInput";
const Io = D(({
  className: e,
  ...o
}, r) => /* @__PURE__ */ t(Hi, {
  calendarClassName: e,
  ref: r,
  ...o
}));
Io.displayName = "DatePickerAdapter";
const $0 = ne(Io, {
  baseStyle: {}
}), _0 = D((e, o) => {
  const {
    datePickerOptions: r,
    value: n,
    onChange: a,
    "data-testid": i,
    showTodayButton: l = !0,
    isReadOnly: s,
    isDisabled: c,
    ...p
  } = e, d = A("DatePicker", {}), u = ue(), h = uo((g) => {
    if (g.currentTarget.value) {
      const f = new Date(g.currentTarget.value.replaceAll("D", "").replaceAll("M", "").replaceAll("Y", ""));
      f instanceof Date && !isNaN(f) && a(f, g);
    }
  }, [a]);
  return /* @__PURE__ */ t(M, {
    children: /* @__PURE__ */ t(
      $0,
      {
        ref: u,
        dateFormat: "yyyy/MM/dd",
        showPopperArrow: !1,
        onChangeRaw: h,
        onChange: a,
        __css: d.container,
        selected: n,
        "data-testid": i,
        ...r,
        readOnly: s,
        disabled: c,
        todayButton: l ? "Today" : void 0,
        onKeyDown: (g) => {
          var f;
          g.code === "Tab" && g.shiftKey && g.target.nodeName == "INPUT" && ((f = u.current) == null || f.setOpen(!1));
        },
        renderCustomHeader: (g) => /* @__PURE__ */ t(C0, {
          ...g,
          dataTestId: i,
          minDate: r == null ? void 0 : r.minDate,
          maxDate: r == null ? void 0 : r.maxDate
        }),
        customInput: /* @__PURE__ */ t(_o, {
          ...p,
          "data-testid": i,
          ref: o
        })
      }
    )
  });
});
_0.displayName = "DatePicker";
const I0 = ({
  controlClassName: e,
  controlStyleProps: o,
  error: r,
  input: n,
  isDisabled: a,
  isReadOnly: i,
  isRequired: l,
  leftInputWidth: s,
  select: c,
  selectPosition: p = "left",
  size: d = "md",
  ...u
}) => {
  const h = A("DualInput"), g = p === "left" ? c : n, f = p === "left" ? n : c;
  return /* @__PURE__ */ t(V, {
    className: e,
    error: r,
    isRequired: l,
    ...o,
    ...u,
    children: /* @__PURE__ */ b(P, {
      direction: "row",
      wrap: "nowrap",
      children: [/* @__PURE__ */ t(M, {
        __css: h.leftElement,
        width: s,
        flex: p === "left" ? void 0 : 1,
        maxW: p === "left" ? "50%" : void 0,
        children: re(g, {
          className: "dual-input-left",
          controlClassName: "dual-input-left-control",
          error: r,
          isDisabled: a,
          isReadOnly: i,
          isRequired: l,
          size: d
        })
      }), (i || g.props.variant === "filled" && f.props.variant === "filled") && /* @__PURE__ */ t(nt, {
        orientation: "vertical",
        borderColor: "gray.200",
        height: "auto",
        border: "0px solid",
        borderWidth: "0 0 0 1px"
      }), /* @__PURE__ */ t(M, {
        __css: h.rightElement,
        flex: p === "left" ? 1 : void 0,
        maxW: p === "left" ? void 0 : "50%",
        children: re(f, {
          className: "dual-input-right",
          controlClassName: "dual-input-right-control",
          error: r,
          isDisabled: a,
          isReadOnly: i,
          isRequired: l,
          size: d
        })
      })]
    })
  });
}, jt = (e, o = !1) => {
  const r = new RegExp(/^(0*\d|1[0-2]):[0-5]\d$/), n = new RegExp(/^(0*\d|1\d|2[0-3]):[0-5]\d$/);
  return (o ? n : r).test(e);
}, z0 = (e, o, r) => {
  o === "pm" ? (r = r >= 0 && r < 12 ? r += 12 : r, e.setHours(r)) : r >= 0 && r < 13 && (r = r === 12 && o === "am" ? 0 : r, e.setHours(r));
}, M0 = (e, o) => {
  o >= 0 && o < 60 ? e.setMinutes(o) : e.setMinutes(0);
}, Ut = (e, o) => {
  const r = new Date();
  r.setSeconds(0);
  const [n, a] = e.replaceAll("H", "").replaceAll("M", "").split(":"), i = parseInt(n, 10), l = parseInt(a, 10);
  return z0(r, o, i), M0(r, l), r;
}, D0 = (e) => {
  const o = { timeField: "", meridiem: "am" }, r = e.getHours();
  o.meridiem = r >= 12 ? "pm" : "am";
  let n = r >= 12 ? r - 12 : r;
  return n = n === 0 && o.meridiem === "pm" ? 12 : n, o.timeField = `${n.toString().padStart(2, "0")}:${e.getMinutes().toString().padStart(2, "0")}`, o;
}, B0 = D((e, o) => {
  const {
    name: r,
    "data-testid": n,
    id: a = r,
    onChange: i,
    placeholder: l,
    value: s,
    variant: c = "outline",
    ...p
  } = e, [d, u] = L(s ? D0(s) : {
    timeField: "",
    meridiem: "am"
  }), h = /* @__PURE__ */ b(ke, {
    name: `${r}-select`,
    id: `${a}-select`,
    "data-testid": n ? `${n}-select` : void 0,
    value: d.meridiem,
    onChange: (f) => {
      const m = f.target.value;
      if (u({
        ...d,
        meridiem: m
      }), jt(d.timeField)) {
        const y = Ut(d.timeField, m);
        i(y, f);
      } else
        i(null, f);
    },
    variant: c,
    children: [/* @__PURE__ */ t("option", {
      value: "am",
      children: "AM"
    }), /* @__PURE__ */ t("option", {
      value: "pm",
      children: "PM"
    })]
  }), g = /* @__PURE__ */ t(Q, {
    ref: o,
    name: `${r}-input`,
    id: a,
    "data-testid": n ? `${n}-input` : void 0,
    format: "##:##",
    mask: ["H", "H", "M", "M"],
    placeholder: l,
    value: d.timeField,
    onChange: (f, m) => {
      if (m.event) {
        const {
          event: y
        } = m;
        y.currentTarget.value = f.formattedValue;
        const x = y.currentTarget.value;
        if (u({
          ...d,
          timeField: x
        }), x && jt(x)) {
          const _ = Ut(x, d.meridiem);
          i(_, y);
        } else
          i(null, y);
      }
    },
    variant: c
  });
  return /* @__PURE__ */ t(I0, {
    name: r,
    id: a,
    select: h,
    input: g,
    selectPosition: "right",
    "data-testid": n,
    ...p
  });
});
B0.displayName = "TimeInput";
const N0 = D((e, o) => {
  const {
    ...r
  } = e;
  return /* @__PURE__ */ t(Q, {
    ref: o,
    format: "####",
    mask: "",
    ...r,
    inputRightElement: /* @__PURE__ */ t(jd, {
      className: "ccinput-right-icon",
      variant: "light"
    })
  });
});
N0.displayName = "CCCvcInput";
const P0 = D((e, o) => {
  const {
    ...r
  } = e;
  return /* @__PURE__ */ t(Q, {
    ref: o,
    format: "##/##",
    mask: ["M", "M", "Y", "Y"],
    ...r
  });
});
P0.displayName = "CCExpiryInput";
var A0 = /* @__PURE__ */ ((e) => (e.AE = "American Express", e.Visa = "Visa", e.MC = "Master Card", e.Discover = "Discover", e.UnknownCard = "Unknown Card", e))(A0 || {});
const T0 = D((e, o) => {
  const {
    onChange: r,
    ...n
  } = e, a = uo((i, l) => {
    let s;
    switch (i.value.charAt(0)) {
      case "3":
        s = "American Express";
        break;
      case "4":
        s = "Visa";
        break;
      case "5":
        s = "Master Card";
        break;
      case "6":
        s = "Discover";
        break;
      default:
        s = "Unknown Card";
        break;
    }
    r && r({
      ...i,
      ccType: s
    }, l);
  }, [r]);
  return /* @__PURE__ */ t(Q, {
    ref: o,
    format: "#### #### #### ####",
    mask: "",
    onChange: a,
    ...n,
    inputRightElement: /* @__PURE__ */ t(Ud, {
      variant: "light",
      color: "gray.400",
      fontSize: "24px"
    })
  });
});
T0.displayName = "CCNumberInput";
const R0 = D((e, o) => {
  const {
    name: r,
    ...n
  } = e;
  return /* @__PURE__ */ t(Q, {
    ref: o,
    name: r,
    decimalScale: 2,
    placeholder: "0.00",
    inputLeftAddon: /* @__PURE__ */ t(Yd, {
      className: "currencyinput-left-addon",
      variant: "light"
    }),
    ...n
  });
});
R0.displayName = "CurrencyInput";
const E0 = D((e, o) => {
  const {
    ...r
  } = e;
  return /* @__PURE__ */ t(Q, {
    ref: o,
    format: "+1 (###) ###-####",
    mask: "_",
    ...r
  });
});
E0.displayName = "PhoneInput";
const zo = He(null), F0 = D((e, o) => {
  const {
    children: r,
    name: n,
    formHelperText: a,
    hideOptionalLabel: i = !1,
    id: l = n,
    label: s,
    onChange: c,
    value: p,
    error: d,
    variant: u = "checkbox",
    controlStyleProps: h,
    controlClassName: g,
    "data-testid": f,
    ...m
  } = e, {
    getCheckboxProps: y
  } = Oi({
    onChange: c,
    value: p
  });
  return /* @__PURE__ */ t(V, {
    formHelperText: a,
    error: d,
    label: s,
    name: n,
    id: l,
    "data-testid": f && `${f}-control`,
    className: g,
    hideOptionalLabel: i,
    ...h,
    ...m,
    children: /* @__PURE__ */ t(zo.Provider, {
      value: {
        getCheckboxProps: y,
        variant: u,
        id: l
      },
      children: r
    })
  });
});
F0.displayName = "CheckboxGroup";
const W0 = () => {
  const e = Le(zo);
  if (!e)
    throw new Error("useCheckboxGroupContext must be used within a CheckboxGroup");
  return e;
}, Mo = ({
  isIndeterminate: e,
  isChecked: o
}) => o ? e ? /* @__PURE__ */ t(Zd, {
  variant: "solid"
}) : /* @__PURE__ */ t(zd, {
  variant: "solid"
}) : null, H0 = D((e, o) => {
  const {
    children: r,
    isDisabled: n = !1,
    isIndeterminate: a = !1,
    size: i = "md",
    value: l,
    id: s,
    ...c
  } = e, {
    getCheckboxProps: p,
    variant: d,
    id: u
  } = W0(), h = p({
    value: l
  }), g = s != null ? s : [u, l].join("-");
  return /* @__PURE__ */ t(Pe, {
    ref: o,
    variant: d,
    size: i,
    id: g,
    isDisabled: n,
    isIndeterminate: a,
    icon: /* @__PURE__ */ t(Mo, {}),
    ...d === "card" && {
      alignItems: "start"
    },
    ...h,
    ...c,
    children: d === "card" ? /* @__PURE__ */ b(E, {
      align: "stretch",
      spacing: {
        base: 2,
        md: 3
      },
      children: [/* @__PURE__ */ t(M, {
        className: "checkbox-card-badge-container",
        children: /* @__PURE__ */ t(kt, {
          className: "checkbox-card-selected-badge",
          status: "recommendation",
          children: "Selected"
        })
      }), /* @__PURE__ */ t(M, {
        className: "checkbox-card-child-container",
        children: r
      })]
    }) : r
  });
});
H0.displayName = "Checkbox";
const L0 = D((e, o) => {
  const {
    children: r,
    name: n,
    formHelperText: a,
    hideOptionalLabel: i = !1,
    id: l = n,
    isIndeterminate: s = !1,
    isRequired: c,
    label: p,
    size: d = "md",
    variant: u = "checkbox",
    value: h,
    error: g,
    onChange: f,
    controlStyleProps: m,
    controlClassName: y,
    "data-testid": x,
    ..._
  } = e;
  return /* @__PURE__ */ t(V, {
    error: g,
    formHelperText: a,
    isRequired: c,
    label: p,
    name: n,
    hideOptionalLabel: i,
    id: l,
    className: y,
    "data-testid": x && `${x}-control`,
    ...m,
    children: /* @__PURE__ */ t(Pe, {
      onChange: (w) => {
        f(w.target.checked);
      },
      isChecked: !!h,
      size: d,
      ref: o,
      variant: u,
      name: n,
      "data-testid": x,
      isIndeterminate: s,
      icon: /* @__PURE__ */ t(Mo, {}),
      ...u === "card" && {
        alignItems: "start"
      },
      ..._,
      children: u === "card" ? /* @__PURE__ */ b(E, {
        align: "stretch",
        spacing: 3,
        children: [/* @__PURE__ */ t(M, {
          className: "checkbox-card-badge-container",
          children: /* @__PURE__ */ t(kt, {
            className: "checkbox-card-selected-badge",
            status: "recommendation",
            children: "Selected"
          })
        }), /* @__PURE__ */ t(M, {
          className: "checkbox-card-child-container",
          children: r
        })]
      }) : r
    })
  });
});
L0.displayName = "BooleanCheckbox";
const Do = D((e, o) => {
  const {
    defaultValue: r,
    min: n,
    max: a,
    onChange: i,
    precision: l,
    size: s = "md",
    step: c,
    value: p,
    variant: d = "outline",
    ...u
  } = e;
  return /* @__PURE__ */ b(Or, {
    defaultValue: r,
    min: n,
    max: a,
    onChange: i,
    precision: l,
    size: s,
    step: c,
    value: p,
    variant: d,
    children: [/* @__PURE__ */ t(Vr, {
      ref: o,
      ...u
    }), /* @__PURE__ */ b(jr, {
      children: [/* @__PURE__ */ t(Ur, {}), /* @__PURE__ */ t(Yr, {})]
    })]
  });
});
Do.displayName = "NumberInputBase";
const G0 = D((e, o) => {
  const {
    name: r,
    error: n,
    hideOptionalLabel: a = !1,
    label: i,
    formHelperText: l,
    controlStyleProps: s,
    controlClassName: c,
    id: p = r,
    isDisabled: d,
    isReadOnly: u,
    isRequired: h,
    "data-testid": g,
    variant: f,
    ...m
  } = e;
  return /* @__PURE__ */ t(V, {
    name: r,
    id: p,
    error: n,
    hideOptionalLabel: a,
    label: i,
    formHelperText: l,
    isDisabled: d,
    isRequired: h,
    isReadOnly: u,
    "data-testid": g && `${g}-control`,
    className: c,
    ...s,
    children: /* @__PURE__ */ t(Do, {
      ref: o,
      name: r,
      "data-testid": g,
      variant: u ? "filled" : f,
      ...m
    })
  });
});
G0.displayName = "NumberInput";
const O0 = ({
  status: e
}) => {
  const o = "password-requirement-status-icon";
  switch (e) {
    case "error":
      return /* @__PURE__ */ t(Ge, {
        variant: "solid",
        color: "red.500",
        className: o
      });
    case "success":
      return /* @__PURE__ */ t($t, {
        variant: "solid",
        color: "green.500",
        className: o
      });
    default:
      return /* @__PURE__ */ t(Dd, {
        variant: "light",
        color: "gray.500",
        className: o
      });
  }
}, V0 = ({
  requirements: e
}) => /* @__PURE__ */ b(E, {
  spacing: 1,
  align: "stretch",
  color: "gray.800",
  children: [/* @__PURE__ */ t($, {
    textStyle: "bodySmall",
    children: "Password must:"
  }), e.map((o) => /* @__PURE__ */ b(Fe, {
    spacing: 2,
    children: [/* @__PURE__ */ t(O0, {
      status: o.status
    }), /* @__PURE__ */ t($, {
      textStyle: "bodySmall",
      children: o.requirement
    })]
  }, o.requirement))]
}), j0 = ({
  isDisabled: e,
  onClick: o
}) => /* @__PURE__ */ t(ft, {
  className: "password-view-toggle",
  children: /* @__PURE__ */ t(O, {
    "aria-label": "Password view toggle",
    variant: "ghost",
    icon: /* @__PURE__ */ t(qd, {
      variant: "solid"
    }),
    onClick: o,
    isDisabled: e
  })
}), U0 = D((e, o) => {
  const {
    name: r,
    className: n,
    controlStyleProps: a,
    controlClassName: i,
    "data-testid": l,
    error: s,
    passwordRequirements: c,
    hideOptionalLabel: p = !1,
    id: d = r,
    isDisabled: u,
    isReadOnly: h,
    isRequired: g,
    label: f,
    variant: m,
    ...y
  } = e, [x, _] = L(!1), w = () => _(!x), k = $e("password-input", n);
  return /* @__PURE__ */ t(V, {
    name: r,
    hideOptionalLabel: p,
    id: d,
    error: s,
    label: f,
    isDisabled: u,
    isReadOnly: h,
    isRequired: g,
    formHelperText: c && c.length > 0 && /* @__PURE__ */ t(V0, {
      requirements: c
    }),
    "data-testid": l && `${l}-control`,
    className: i,
    ...a,
    children: /* @__PURE__ */ t(zt, {
      ref: o,
      name: r,
      className: k,
      "data-testid": l,
      type: x ? "text" : "password",
      inputRightElementOverride: /* @__PURE__ */ t(j0, {
        onClick: w,
        isDisabled: u
      }),
      variant: h ? "filled" : m,
      ...y
    })
  });
});
U0.displayName = "PasswordInput";
const Bo = He(null), Y0 = D((e, o) => {
  const {
    children: r,
    error: n,
    formHelperText: a,
    hideOptionalLabel: i = !1,
    isRequired: l,
    label: s,
    name: c,
    id: p = c,
    onChange: d,
    value: u,
    variant: h = "radio",
    controlStyleProps: g,
    controlClassName: f,
    "data-testid": m,
    ...y
  } = e, x = (w) => {
    d(w === "true" ? !0 : w === "false" ? !1 : w);
  }, {
    getRadioProps: _
  } = Vi({
    name: c,
    onChange: x,
    value: typeof u == "boolean" ? `${u}` : u
  });
  return /* @__PURE__ */ t(V, {
    error: n,
    hideOptionalLabel: i,
    isRequired: l,
    label: s,
    name: c,
    id: p,
    formHelperText: a,
    "data-testid": m && `${m}-control`,
    className: f,
    ...g,
    ...y,
    children: /* @__PURE__ */ t(Bo.Provider, {
      value: {
        getRadioProps: _,
        variant: h,
        id: p
      },
      children: r
    })
  });
});
Y0.displayName = "RadioGroup";
const q0 = () => {
  const e = Le(Bo);
  if (!e)
    throw new Error("useRadioGroupContext must be used within a RadioGroup");
  return e;
}, X0 = D((e, o) => {
  const {
    children: r,
    id: n,
    isDisabled: a,
    size: i = "md",
    value: l,
    ...s
  } = e, {
    getRadioProps: c,
    variant: p,
    id: d
  } = q0(), u = c({
    value: l
  }), h = n != null ? n : [d, l].join("-");
  return /* @__PURE__ */ t(M, {
    w: "fit-content",
    ...s,
    children: /* @__PURE__ */ t(qr, {
      ref: o,
      ...u,
      id: h,
      isDisabled: a,
      size: i,
      variant: p,
      children: p === "card" ? /* @__PURE__ */ b(E, {
        align: "stretch",
        spacing: {
          base: 2,
          md: 3
        },
        children: [/* @__PURE__ */ t(M, {
          className: "radio-card-badge-container",
          children: /* @__PURE__ */ t(kt, {
            className: "radio-card-selected-badge",
            status: "recommendation",
            children: "Selected"
          })
        }), /* @__PURE__ */ t(M, {
          className: "radio-card-child-container",
          children: r
        })]
      }) : r
    })
  });
});
X0.displayName = "Radio";
const Z0 = ({
  orientation: e = "horizontal",
  ...o
}) => /* @__PURE__ */ b(Xr, {
  orientation: e,
  ...o,
  children: [/* @__PURE__ */ t(Zr, {
    children: /* @__PURE__ */ t(Kr, {})
  }), /* @__PURE__ */ t(Jr, {})]
}), mu = ({
  name: e,
  error: o,
  hideOptionalLabel: r = !1,
  label: n,
  formHelperText: a,
  controlStyleProps: i,
  controlClassName: l,
  id: s = e,
  isReadOnly: c,
  isRequired: p,
  "data-testid": d,
  ...u
}) => /* @__PURE__ */ t(V, {
  name: e,
  id: `slider-thumb-${s}`,
  error: o,
  hideOptionalLabel: r,
  label: n,
  formHelperText: a,
  isRequired: p,
  isReadOnly: c,
  "data-testid": d && `${d}-control`,
  className: l,
  ...i,
  children: /* @__PURE__ */ t(Z0, {
    name: e,
    id: s,
    isReadOnly: c,
    "data-testid": d,
    ...u
  })
}), K0 = D((e, o) => {
  const {
    name: r,
    controlClassName: n,
    controlStyleProps: a,
    "data-testid": i,
    error: l,
    formHelperText: s,
    hideOptionalLabel: c = !1,
    id: p = r,
    isDisabled: d,
    isReadOnly: u,
    isRequired: h,
    label: g,
    placeholder: f,
    size: m = "md",
    variant: y = "outline",
    ...x
  } = e;
  return /* @__PURE__ */ t(V, {
    name: r,
    hideOptionalLabel: c,
    id: p,
    error: l,
    label: g,
    isDisabled: d,
    isReadOnly: u,
    isRequired: h,
    formHelperText: s,
    "data-testid": i && `${i}-control`,
    className: n,
    ...a,
    children: /* @__PURE__ */ t(Qr, {
      size: m,
      placeholder: f,
      ref: o,
      name: r,
      "data-testid": i,
      focusBorderColor: "teal.500",
      variant: u ? "filled" : y,
      ...x
    })
  });
});
K0.displayName = "Input";
const J0 = ({
  size: e = "md",
  src: o,
  ...r
}) => {
  const [n, a] = L(!1);
  return /* @__PURE__ */ t(en, {
    size: e,
    src: o,
    onError: () => a(!0),
    ...o && !n && {
      background: "none"
    },
    ...r
  });
}, No = ({
  children: e,
  as: o,
  to: r,
  ...n
}) => /* @__PURE__ */ t(tn, {
  ...n,
  children: typeof e == "object" ? e : /* @__PURE__ */ t(lo, {
    as: o,
    href: r,
    children: e
  })
}), Po = ({
  children: e,
  ...o
}) => /* @__PURE__ */ t(on, {
  autoSelect: !1,
  ...o,
  children: e
}), Ao = ({
  children: e,
  as: o,
  href: r,
  isDisabled: n,
  ...a
}) => /* @__PURE__ */ t(rn, {
  isDisabled: n,
  as: n ? void 0 : o,
  href: n ? void 0 : r,
  to: !n && r ? r : void 0,
  ...a,
  children: e
}), fu = ({
  children: e,
  ...o
}) => /* @__PURE__ */ t(nn, {
  ...o,
  children: e
}), yu = ({
  ...e
}) => /* @__PURE__ */ t(an, {
  ...e
}), To = ({
  children: e,
  ...o
}) => /* @__PURE__ */ t(ln, {
  ...o,
  children: e
}), Ro = ({
  children: e,
  ...o
}) => /* @__PURE__ */ t(sn, {
  ...o,
  children: e
}), Q0 = ({
  items: e
}) => {
  const o = [...e];
  return o.shift(), o.pop(), o.pop(), /* @__PURE__ */ b(Po, {
    children: [/* @__PURE__ */ t(Ro, {
      children: "..."
    }), /* @__PURE__ */ t(To, {
      children: o.map((r, n) => /* @__PURE__ */ t(Ao, {
        as: r.as || lo,
        href: r.to,
        children: r.label
      }, n))
    })]
  });
}, ep = (e) => {
  const o = [];
  return o.push(e[0]), o.push(e[e.length - 2]), o.push(e[e.length - 1]), o;
}, ot = ({
  item: e,
  ...o
}) => /* @__PURE__ */ t(No, {
  as: e.as,
  to: e.to,
  isCurrentPage: e.isCurrent,
  ...o,
  children: e.label
}), xu = ({
  options: e,
  as: o,
  ...r
}) => {
  o && e.forEach((l) => l.as = o);
  let a = [];
  return e.length > 3 ? a = ep(e) : a = e, G(() => a.findIndex((l) => l.isCurrent === !0), [a]) === -1 && (a[a.length - 1].isCurrent = !0), /* @__PURE__ */ b(cn, {
    separator: "/",
    ...r,
    children: [a[0] && /* @__PURE__ */ t(ot, {
      item: a[0]
    }), e.length > 3 && /* @__PURE__ */ t(No, {
      children: /* @__PURE__ */ t(Q0, {
        items: e
      })
    }), a[1] && /* @__PURE__ */ t(ot, {
      item: a[1]
    }), a[2] && /* @__PURE__ */ t(ot, {
      item: a[2]
    })]
  });
}, oe = ({
  as: e,
  children: o,
  href: r,
  size: n = "md",
  ...a
}) => /* @__PURE__ */ t(We, {
  as: e,
  href: r,
  to: e && r ? r : void 0,
  size: n,
  ...a,
  children: o
}), tp = ({
  brandAs: e,
  brand: o,
  brandUrl: r,
  logo: n
}) => {
  const a = ae({
    base: !0,
    md: !1
  }, {
    fallback: "md"
  });
  return /* @__PURE__ */ t(oe, {
    href: r,
    as: e,
    lineHeight: 0,
    textDecoration: "none",
    children: /* @__PURE__ */ b(Fe, {
      children: [n || /* @__PURE__ */ t(wd, {
        variant: "grayscale",
        width: "100px"
      }), o && !a && /* @__PURE__ */ t($, {
        variant: "subheading1",
        textDecoration: "none",
        color: "gray.800",
        whiteSpace: "nowrap",
        children: o
      })]
    })
  });
}, op = ({
  brand: e,
  brandAs: o,
  brandUrl: r,
  hideLogInButton: n = !1,
  hideSearchField: a = !1,
  hideSignUpButton: i = !1,
  logo: l,
  isSignedIn: s = !1,
  onSearchChange: c = () => {
  },
  onSignIn: p,
  onSignOut: d,
  onSignUp: u,
  userMenuItems: h,
  ...g
}) => {
  const f = A("GlobalHeader"), m = ae({
    base: !0,
    md: !1
  }, {
    fallback: "md"
  });
  return /* @__PURE__ */ t(j, {
    children: /* @__PURE__ */ b(P, {
      sx: f.container,
      as: "header",
      ...g,
      children: [/* @__PURE__ */ t(tp, {
        brandUrl: r,
        logo: l,
        brand: e,
        brandAs: o
      }), /* @__PURE__ */ t(dn, {
        flexGrow: "2",
        minWidth: "5",
        flexShrink: "2"
      }), /* @__PURE__ */ b(P, {
        gap: s ? 5 : 3,
        alignItems: "center",
        flexGrow: "1",
        justifyContent: "flex-end",
        flexShrink: "1",
        children: [!a && !m && /* @__PURE__ */ t(Mt, {
          name: "headerSearch",
          size: "sm",
          onSearch: c,
          controlStyleProps: {
            flexBasis: "340px",
            flexShrink: "1"
          }
        }), s && /* @__PURE__ */ t(_d, {
          variant: "light",
          size: "md",
          color: "teal.500"
        }), s && /* @__PURE__ */ b(Po, {
          children: [/* @__PURE__ */ t(Ro, {
            children: /* @__PURE__ */ t(J0, {
              size: "sm"
            })
          }), /* @__PURE__ */ b(To, {
            children: [h, /* @__PURE__ */ t(Ao, {
              onClick: d,
              children: "Sign out"
            })]
          })]
        }), !s && !n && /* @__PURE__ */ t(Y, {
          size: "sm",
          variant: "secondary",
          onClick: p,
          children: "Log in"
        }), !s && !i && /* @__PURE__ */ t(Y, {
          size: "sm",
          variant: "primary",
          onClick: u,
          children: "Sign up"
        })]
      })]
    })
  });
}, Su = (e) => /* @__PURE__ */ t(op, {
  ...e
}), rp = () => /* @__PURE__ */ b("svg", {
  height: "100%",
  viewBox: "0 0 344 288",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ b("g", {
    clipPath: "url(#clip0_4237_28706)",
    children: [/* @__PURE__ */ t("rect", {
      width: "344",
      height: "300",
      fill: "white"
    }), /* @__PURE__ */ t("ellipse", {
      cx: "388.147",
      cy: "-55.3846",
      rx: "163.4",
      ry: "230.769",
      fill: "#DFE33E"
    }), /* @__PURE__ */ t("path", {
      d: "M103.342 683.898C52.8999 589.855 25.6248 459.864 42.7917 342.287C52.965 272.609 83.6558 217.348 120.242 171.481C151.555 132.225 187.651 98.3959 229.505 87.3602C258.214 79.7904 291.316 83.4967 314.998 109.929C341.291 139.275 353.041 189.14 362.535 232.52C373.895 284.424 381.72 338.786 385.038 392.939C387.654 435.627 385.324 477.369 384.767 520.017",
      stroke: "#3AC2CE",
      strokeWidth: 2,
      strokeLinecap: "round"
    }), /* @__PURE__ */ t("path", {
      d: "M338.267 -523.729C321.581 -507.178 314.491 -474.219 307.179 -452.542C261.46 -317.001 220.403 -176.367 196.59 -33.898C161.496 176.058 170.147 393.799 237.36 595.481C278.738 719.643 343.14 814.11 420.827 910.17",
      stroke: "#DFE33E",
      strokeWidth: 2,
      strokeLinecap: "round"
    })]
  }), /* @__PURE__ */ t("defs", {
    children: /* @__PURE__ */ t("clipPath", {
      id: "clip0_4237_28706",
      children: /* @__PURE__ */ t("rect", {
        width: "344",
        height: "300",
        fill: "white"
      })
    })
  })]
}), vu = ({
  bottomElement: e,
  children: o,
  topElement: r,
  ...n
}) => {
  const [a, i] = L(0), l = ue(null), s = A("PageHeader"), c = ae({
    base: !0,
    md: !1
  }, {
    fallback: "md"
  });
  return U(() => {
    l && l.current && i(l.current.clientHeight);
  }, [l]), /* @__PURE__ */ b(P, {
    sx: s.container,
    ...n,
    children: [/* @__PURE__ */ b(E, {
      sx: s.content,
      spacing: 4,
      align: "stretch",
      ref: l,
      children: [r, /* @__PURE__ */ t($, {
        variant: "h1",
        children: o
      }), e]
    }), !c && /* @__PURE__ */ t(M, {
      sx: s.graphic,
      ...a !== 0 && {
        height: `${a}px`
      },
      children: /* @__PURE__ */ t(rp, {})
    })]
  });
}, Eo = He(null), np = {
  activeStep: 1
}, ap = () => {
  const e = Le(Eo);
  if (!e)
    throw new Error("useStepsContext must be used within a Steps component.");
  return e;
}, ip = ({
  step: e = 0,
  stepState: o,
  ...r
}) => {
  const n = {
    variant: "solid",
    size: "xl"
  };
  if (o === "active")
    return /* @__PURE__ */ t(Ld, {
      ...n,
      ...r
    });
  if (o === "complete")
    return /* @__PURE__ */ t($t, {
      ...n,
      ...r
    });
  switch (e) {
    case 1:
      return /* @__PURE__ */ t(Nd, {
        ...n,
        ...r
      });
    case 2:
      return /* @__PURE__ */ t(Pd, {
        ...n,
        ...r
      });
    case 3:
      return /* @__PURE__ */ t(Ad, {
        ...n,
        ...r
      });
    case 4:
      return /* @__PURE__ */ t(Td, {
        ...n,
        ...r
      });
    case 5:
      return /* @__PURE__ */ t(Rd, {
        ...n,
        ...r
      });
    case 6:
      return /* @__PURE__ */ t(Ed, {
        ...n,
        ...r
      });
    case 7:
      return /* @__PURE__ */ t(Fd, {
        ...n,
        ...r
      });
    case 8:
      return /* @__PURE__ */ t(Wd, {
        ...n,
        ...r
      });
    case 9:
      return /* @__PURE__ */ t(Hd, {
        ...n,
        ...r
      });
    default:
      return /* @__PURE__ */ t(Bd, {
        ...n,
        ...r
      });
  }
}, lp = (e) => {
  let o = 0;
  return e === "complete" ? o = 100 : e === "active" && (o = 50), o;
}, Yt = (e, o, r) => {
  o ? e.preventDefault() : r();
}, sp = (e, o) => {
  var a;
  const n = o - 1;
  if (e && e.current) {
    const i = e.current.children[0].children, l = i[n].clientWidth + 4;
    let s = 0;
    for (let c = 0; c <= n; c++)
      s += i[c].clientWidth + 4;
    (a = e.current) == null || a.scrollTo(
      0 - e.current.offsetWidth / 2 + s - l * 0.5 + 4,
      0
    );
  }
}, Cu = ({
  children: e,
  className: o,
  isLast: r = !1,
  stepNumber: n,
  variant: a,
  ...i
}) => {
  const {
    stepsState: l,
    handleStepClick: s,
    disableStepClick: c,
    id: p
  } = ap();
  a = n && l.activeStep === n ? "active" : a;
  const d = A("Steps", {
    variant: a
  });
  return c && (o = $e("disable-pointer-events", o)), /* @__PURE__ */ b(P, {
    sx: d.stepDetails,
    onClick: (u) => {
      Yt(u, c, () => s(u, n != null ? n : 1));
    },
    onKeyDown: (u) => {
      (u.key === " " || u.key === "Enter") && Yt(u, c, () => s(u, n != null ? n : 1));
    },
    id: `${p}-details-${n}`,
    className: o,
    flex: {
      base: r ? 0 : 1,
      md: 1
    },
    tabIndex: 0,
    ...i,
    children: [/* @__PURE__ */ t(ko, {
      "aria-label": `Step ${n} progress`,
      value: lp(a),
      sx: d.stepProgress,
      className: "step-progress",
      display: {
        base: r ? "none" : "flex",
        md: "flex"
      }
    }), /* @__PURE__ */ t(ip, {
      step: n,
      stepState: a,
      sx: d.icon,
      mr: {
        base: r ? 0 : 1,
        md: 2
      }
    }), /* @__PURE__ */ t($, {
      className: "step-label",
      children: e
    })]
  });
}, qt = () => {
  const {
    innerWidth: e,
    innerHeight: o
  } = window;
  return {
    width: e,
    height: o
  };
}, cp = () => {
  const [e, o] = L(qt());
  return U(() => {
    function r() {
      o(qt());
    }
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, []), e;
}, wu = ({
  children: e,
  activeStep: o,
  disableStepClick: r = !1,
  id: n = "steps-component",
  onStepClick: a,
  ...i
}) => {
  const l = A("Steps"), s = ie(e), c = ue(null), p = 5, {
    width: d
  } = cp(), [u, h] = L(0), g = ae({
    base: !0,
    md: !1
  }, {
    fallback: "md"
  });
  U(() => {
    s.length > p && h(d / (p + 0.8));
  }, [d]);
  const f = {
    ...np
  };
  o && (f.activeStep = o);
  const [m, y] = L(f);
  U(() => {
    o && y({
      ...m,
      activeStep: o
    });
  }, [o]);
  const x = (w, k) => {
    y({
      ...m,
      activeStep: k
    }), a && a(k), g && sp(c, k);
  }, _ = () => /* @__PURE__ */ t(P, {
    sx: l.container,
    id: n,
    ...i,
    ...g && s.length > p && {
      width: "fit-content"
    },
    children: s.length > 0 && s.map((w, k) => re(w, {
      stepNumber: k + 1,
      isLast: k + 1 === s.length,
      width: g && s.length > p ? u : "100%"
    }))
  });
  return /* @__PURE__ */ t(Eo.Provider, {
    value: {
      stepsState: m,
      setStepsState: y,
      handleStepClick: x,
      disableStepClick: r,
      id: n
    },
    children: /* @__PURE__ */ b(E, {
      align: "stretch",
      spacing: 1,
      children: [g ? /* @__PURE__ */ t(ne.div, {
        className: "tabs-scrollable",
        sx: l.scrollable,
        ref: c,
        children: /* @__PURE__ */ t(_, {})
      }) : /* @__PURE__ */ t(_, {}), g && s[m.activeStep - 1] && /* @__PURE__ */ t($, {
        className: "step-mobile-label",
        textStyle: "bodyBold",
        textAlign: "center",
        color: "teal.700",
        children: s[m.activeStep - 1].props.children
      })]
    })
  });
}, ku = ({
  bodyStyleProps: e,
  isOpen: o,
  onClose: r,
  cancelRef: n,
  children: a,
  closeOnEsc: i,
  closeOnOverlayClick: l,
  dialogStyleProps: s,
  footer: c,
  headerStyleProps: p,
  id: d,
  isCentered: u,
  onEsc: h,
  onOverlayClick: g,
  title: f,
  showCloseButton: m = !0,
  footerStyleProps: y,
  "data-testid": x,
  ..._
}) => /* @__PURE__ */ t(pn, {
  leastDestructiveRef: n,
  isOpen: o,
  onClose: r,
  closeOnEsc: i,
  closeOnOverlayClick: l,
  id: d,
  isCentered: u,
  onEsc: h,
  onOverlayClick: g,
  children: /* @__PURE__ */ t(un, {
    children: /* @__PURE__ */ b(bn, {
      "data-testid": x,
      ...s,
      ..._,
      children: [/* @__PURE__ */ t(hn, {
        "data-testid": x && `${x}-header`,
        ...p,
        children: f
      }), m && /* @__PURE__ */ t(gn, {}), a && /* @__PURE__ */ t(mn, {
        "data-testid": x && `${x}-body`,
        ...e,
        children: a
      }), c && /* @__PURE__ */ t(fn, {
        "data-testid": x && `${x}-footer`,
        ...y,
        children: c
      })]
    })
  })
}), dp = ({
  onCancelClick: e,
  onContinueClick: o
}) => {
  const r = ae({
    base: !0,
    md: !1
  }, {
    fallback: "md"
  });
  return /* @__PURE__ */ b(P, {
    gap: 3,
    width: "100%",
    justifyContent: {
      base: "space-between",
      md: "flex-end"
    },
    children: [/* @__PURE__ */ t(Y, {
      size: "sm",
      variant: "tertiary",
      isFullWidth: r,
      ...e && {
        onClick: e
      },
      children: "Cancel"
    }), /* @__PURE__ */ t(Y, {
      size: "sm",
      variant: "primary",
      isFullWidth: r,
      ...o && {
        onClick: o
      },
      children: "Continue"
    })]
  });
}, pp = (e, o) => {
  let r = "xl";
  return e ? r = "full" : o && (r = "sm"), r;
}, $u = ({
  isOpen: e,
  onClose: o,
  children: r,
  closeOnEsc: n,
  closeOnOverlayClick: a,
  footer: i,
  isCentered: l,
  id: s,
  isFullScreen: c = !1,
  modalContentProps: p,
  modalHeaderProps: d,
  onCancelClick: u,
  onContinueClick: h,
  onEsc: g,
  onOverlayClick: f,
  scrollBehavior: m,
  showCloseButton: y = !0,
  title: x,
  useInert: _,
  "data-testid": w,
  ...k
}) => {
  const T = ae({
    base: !0,
    md: !1
  }, {
    fallback: "md"
  });
  return /* @__PURE__ */ b(yn, {
    id: s,
    isOpen: e,
    onClose: o,
    closeOnEsc: n,
    closeOnOverlayClick: a,
    isCentered: l,
    onEsc: g,
    onOverlayClick: f,
    scrollBehavior: m,
    useInert: _,
    size: pp(c, T),
    children: [/* @__PURE__ */ t(xn, {}), /* @__PURE__ */ b(Sn, {
      "data-testid": w,
      ...p,
      ...k,
      children: [x && /* @__PURE__ */ t(vn, {
        "data-testid": w && `${w}-header`,
        ...d,
        children: x
      }), y && /* @__PURE__ */ t(Cn, {
        size: T ? "sm" : "md"
      }), /* @__PURE__ */ t(wn, {
        "data-testid": w && `${w}-body`,
        children: r
      }), /* @__PURE__ */ t(kn, {
        "data-testid": w && `${w}-footer`,
        children: i || /* @__PURE__ */ t(dp, {
          onCancelClick: u,
          onContinueClick: h
        })
      })]
    })]
  });
}, _u = ({
  children: e,
  ...o
}) => /* @__PURE__ */ t($n, {
  hasArrow: !0,
  ...o,
  children: e
}), Iu = ({
  children: e,
  popoverTrigger: o,
  bodyStyleProps: r,
  closeOnBlur: n = !0,
  closeOnEsc: a = !0,
  footer: i,
  footerStyleProps: l,
  header: s,
  headerStyleProps: c,
  id: p,
  onClose: d,
  onOpen: u,
  placement: h = "bottom",
  showCloseButton: g = !0,
  trigger: f = "click",
  "data-testid": m,
  ...y
}) => /* @__PURE__ */ b(bt, {
  id: p,
  closeOnBlur: n,
  closeOnEsc: a,
  onClose: d,
  onOpen: u,
  placement: h,
  trigger: f,
  children: [/* @__PURE__ */ t(ht, {
    children: o
  }), /* @__PURE__ */ b(gt, {
    "data-testid": m,
    ...y,
    children: [/* @__PURE__ */ t(_n, {}), g && /* @__PURE__ */ t(In, {}), s ? /* @__PURE__ */ t(zn, {
      "data-testid": m && `${m}-header`,
      ...c,
      children: s
    }) : g && /* @__PURE__ */ t(M, {
      className: "headerspacer"
    }), /* @__PURE__ */ t(mt, {
      "data-testid": m && `${m}-body`,
      ...r,
      children: e
    }), i && /* @__PURE__ */ t(Mn, {
      "data-testid": m && `${m}-footer`,
      ...l,
      children: i
    })]
  })]
}), fe = () => /* @__PURE__ */ t($, {
  display: {
    base: "none",
    md: "inline"
  },
  color: "gray.700",
  children: "|"
}), up = () => {
  const e = A("Footer");
  return /* @__PURE__ */ b(P, {
    sx: e.defaultContent,
    children: [/* @__PURE__ */ t(oe, {
      href: "https://www.sgi.sk.ca",
      isExternal: !0,
      children: "sgi.sk.ca"
    }), /* @__PURE__ */ t(fe, {}), /* @__PURE__ */ t(oe, {
      href: "https://www.sgicanada.ca",
      isExternal: !0,
      children: "sgicanada.ca"
    }), /* @__PURE__ */ t(fe, {}), /* @__PURE__ */ t(oe, {
      href: "https://www.sgi.sk.ca/salvage",
      isExternal: !0,
      children: "sgi salvage"
    }), /* @__PURE__ */ t(fe, {}), /* @__PURE__ */ t(oe, {
      href: "https://www.sgi.sk.ca/terms",
      isExternal: !0,
      children: "Terms of use"
    }), /* @__PURE__ */ t(fe, {}), /* @__PURE__ */ t(oe, {
      href: "https://www.sgi.sk.ca/privacy",
      isExternal: !0,
      children: "Privacy statement"
    }), /* @__PURE__ */ t(fe, {}), /* @__PURE__ */ t(oe, {
      children: "Feedback"
    }), /* @__PURE__ */ b($, {
      children: ["\xA9 SGI ", new Date().getFullYear()]
    })]
  });
}, zu = ({
  children: e,
  hideCommentButton: o = !1,
  onCommentClick: r,
  stickToBottom: n = !1,
  ...a
}) => {
  const l = A("Footer", {
    variant: n ? "stickToBottom" : "basic"
  });
  return /* @__PURE__ */ b(xe, {
    as: "footer",
    __css: l.container,
    ...a,
    children: [ie(e).length > 0 ? e : /* @__PURE__ */ t(up, {}), !o && /* @__PURE__ */ t(O, {
      "aria-label": "Click to comment",
      icon: /* @__PURE__ */ t(Vd, {
        variant: "light",
        size: "2xl"
      }),
      onClick: r,
      size: "lg",
      sx: l.chatIcon
    })]
  });
}, Fo = He(null), rt = {
  activeCategory: "",
  openCategory: "",
  activeItem: ""
}, bp = ({
  children: e,
  id: o = "globalNav",
  linkAs: r,
  ...n
}) => {
  const [a, i] = L(rt), l = A("GlobalNav"), {
    isOpen: s,
    onClose: c,
    onOpen: p
  } = Dn(), d = ue();
  Bn({
    ref: d,
    handler: () => s && c()
  });
  const u = ie(e), h = (m, y) => {
    y === 0 ? (i({
      ...a,
      activeCategory: m.currentTarget.id,
      activeItem: rt.activeItem
    }), c()) : a.openCategory !== m.currentTarget.id ? i({
      ...a,
      openCategory: m.currentTarget.id
    }) : y !== 0 && p();
  }, g = (m) => {
    const y = {
      ...a,
      activeItem: m.currentTarget.id
    };
    y.activeCategory = y.openCategory, i(y), c();
  }, f = () => {
    i(rt);
  };
  return /* @__PURE__ */ t(Fo.Provider, {
    value: {
      globalNavState: a,
      setGlobalNavState: i,
      resetState: f,
      isOpen: s,
      onOpen: p,
      onClose: c,
      handleCategoryOnClick: h,
      handleItemOnClick: g,
      linkAs: r
    },
    children: /* @__PURE__ */ t(P, {
      __css: l.globalNavTopContainer,
      flexDir: "column",
      ref: d,
      id: o,
      ...n,
      children: /* @__PURE__ */ t(P, {
        __css: l.globalNavNavContainer,
        as: "nav",
        flexDir: "column",
        id: "globalNav-nav",
        children: u.length > 0 && u.map((m, y) => {
          const x = `category${y}`;
          return re(m, {
            id: x
          });
        })
      })
    })
  });
}, Mu = (e) => /* @__PURE__ */ t(bp, {
  ...e
}), Ie = () => {
  const e = Le(Fo);
  if (!e)
    throw new Error("useGlobalNavContext must be used within a GlobalNav component.");
  return e;
}, hp = ({
  children: e
}) => {
  const o = A("GlobalNav"), {
    isOpen: r
  } = Ie(), [n, a] = L(!r);
  return /* @__PURE__ */ t(j, {
    children: /* @__PURE__ */ t(Pi.div, {
      hidden: n,
      initial: !1,
      onAnimationStart: () => a(!1),
      onAnimationComplete: () => a(!r),
      animate: {
        width: r ? Kc - Be : 0
      },
      style: o.globalNavMenuSlider,
      children: e
    })
  });
}, gp = ({
  as: e,
  children: o,
  href: r,
  icon: n,
  id: a,
  label: i,
  onClick: l,
  onKeyDown: s,
  ...c
}) => {
  const {
    globalNavState: p,
    isOpen: d,
    onOpen: u,
    onClose: h,
    handleCategoryOnClick: g,
    linkAs: f
  } = Ie(), m = p.activeCategory === a, y = p.openCategory === a, _ = A("GlobalNav", {
    variant: y && d ? "open" : m ? "active" : ""
  }), w = ie(o).length;
  U(() => {
    p.openCategory !== "" && (w > 0 && y && u(), w === 0 && h());
  }, [p.openCategory]);
  const k = (F) => {
    l && l(F), g(F, w);
  }, T = (F) => {
    s && s(F), (F.key === " " || F.key === "Enter") && g(F, w);
  };
  return /* @__PURE__ */ b(j, {
    children: [/* @__PURE__ */ t(We, {
      as: r && f ? f : e,
      href: r,
      to: r || void 0,
      sx: _.globalNavCategory,
      onClick: k,
      onKeyDown: T,
      value: i,
      id: a,
      tabIndex: 0,
      ...c,
      children: /* @__PURE__ */ b(E, {
        spacing: "2",
        children: [n && /* @__PURE__ */ t(ao, {
          __css: _.globalNavCategoryIcon,
          children: n
        }), i && /* @__PURE__ */ t($, {
          children: i
        })]
      })
    }), y && /* @__PURE__ */ t(hp, {
      children: o
    })]
  });
}, Du = (e) => /* @__PURE__ */ t(gp, {
  ...e
}), mp = ({
  children: e,
  ...o
}) => {
  const r = A("GlobalNav"), {
    globalNavState: n
  } = Ie(), a = ie(e);
  return /* @__PURE__ */ t(E, {
    sx: r.globalNavMenu,
    role: "menu",
    align: "stretch",
    divider: /* @__PURE__ */ t(so, {
      sx: r.globalNavMenuDivider
    }),
    spacing: "6",
    ...o,
    children: a.length > 0 && a.map((i, l) => {
      const s = `${n.openCategory}-item${l}`;
      return re(i, {
        id: s
      });
    })
  });
}, Bu = (e) => /* @__PURE__ */ t(mp, {
  ...e
}), fp = ({
  as: e,
  children: o,
  href: r,
  id: n,
  isDisabled: a,
  label: i,
  ...l
}) => {
  const {
    globalNavState: s,
    handleItemOnClick: c,
    linkAs: p
  } = Ie(), d = a ? "disabled" : s.activeItem === n ? "active" : "", u = A("GlobalNav", {
    variant: d
  }), h = ie(o);
  return /* @__PURE__ */ b(j, {
    children: [/* @__PURE__ */ t(We, {
      role: "menuitem",
      display: "block",
      sx: u.globalNavMenuLink,
      onClick: !a && r ? c : void 0,
      id: n,
      as: !a && r && p ? p : e,
      href: a ? void 0 : r,
      to: !a && r ? r : void 0,
      ...l,
      children: i
    }), h.length > 0 && h.map((g) => {
      const f = `${n}-sub`;
      return re(g, {
        id: f
      });
    })]
  });
}, Nu = (e) => /* @__PURE__ */ t(fp, {
  ...e
}), yp = ({
  children: e,
  id: o,
  ...r
}) => {
  const n = A("GlobalNav"), a = ie(e);
  return /* @__PURE__ */ t(E, {
    sx: n.globalNavSubMenu,
    role: "group",
    align: "stretch",
    spacing: "0.5",
    ...r,
    children: a.length > 0 && a.map((i, l) => {
      const s = `${o}item${l}`;
      return re(i, {
        id: s
      });
    })
  });
}, Pu = (e) => /* @__PURE__ */ t(yp, {
  ...e
}), xp = ({
  as: e,
  href: o,
  id: r,
  isDisabled: n,
  label: a,
  ...i
}) => {
  const {
    globalNavState: l,
    handleItemOnClick: s,
    linkAs: c
  } = Ie(), p = n ? "disabled" : l.activeItem === r ? "active" : "", d = A("GlobalNav", {
    variant: p
  });
  return /* @__PURE__ */ t(j, {
    children: /* @__PURE__ */ t(
      We,
      {
        sx: d.globalNavSubMenuLink,
        display: "block",
        role: "menuitem",
        onClick: !n && o ? s : void 0,
        id: r,
        as: !n && o && c ? c : e,
        href: n ? void 0 : o,
        to: !n && o ? o : void 0,
        ...i,
        children: a
      }
    )
  });
}, Au = (e) => /* @__PURE__ */ t(xp, {
  ...e
});
function Xt(e) {
  return e / 1024;
}
function Sp(e) {
  return e / 1024 ** 2;
}
function Wo(e) {
  return !e || e < 0 ? "" : e < 10 ? `${e} bytes` : e < 900 ? `${Xt(e).toFixed(2)} KB` : e < 1024 ** 2 ? `${Xt(e).toFixed(0)} KB` : `${Sp(e).toFixed(0)} MB`;
}
const vp = ({
  file: e,
  progressPercentage: o,
  error: r,
  onRemoveFile: n,
  abort: a
}) => {
  const i = G(() => r ? "error" : o === 100 ? "success" : "uploading", [o, r]), [l, s] = L(!0);
  return U(() => {
    let c;
    return i === "success" ? c = window.setTimeout(() => s(!1), 3e3) : s(!0), () => {
      c && clearTimeout(c);
    };
  }, [i]), /* @__PURE__ */ b(J, {
    children: [/* @__PURE__ */ b(P, {
      gap: 4,
      alignItems: "end",
      children: [/* @__PURE__ */ b(J, {
        flexGrow: 1,
        children: [/* @__PURE__ */ b($, {
          noOfLines: 1,
          variant: "bodySmall",
          children: [e.name, " ", /* @__PURE__ */ b(M, {
            color: "gray.600",
            as: "span",
            children: ["(", Wo(e.size), ")"]
          })]
        }), /* @__PURE__ */ t(ko, {
          size: "sm",
          "aria-label": `Upload proress for ${e.name}`,
          value: o
        })]
      }), i === "uploading" && n && /* @__PURE__ */ t(Y, {
        onClick: () => {
          n(e), a == null || a();
        },
        variant: "tertiary",
        children: "Cancel"
      }), i === "success" && /* @__PURE__ */ t(Fe, {
        spacing: 4,
        children: n && /* @__PURE__ */ t(Y, {
          onClick: () => n(e),
          variant: "tertiary",
          isDestructive: !0,
          children: "Delete"
        })
      })]
    }), /* @__PURE__ */ t(Nn, {
      in: l,
      animateOpacity: !0,
      children: i === "error" ? /* @__PURE__ */ t(So, {
        children: r
      }) : i === "success" ? /* @__PURE__ */ t($, {
        variant: "bodySmall",
        color: "green.500",
        children: "Upload complete."
      }) : /* @__PURE__ */ b($, {
        variant: "bodySmall",
        type: "secondary",
        children: ["Uploading... ", o ? `${o}%` : ""]
      })
    })]
  });
}, Cp = ({
  files: e = [],
  onRemoveFile: o
}) => /* @__PURE__ */ t(J, {
  spacing: 4,
  divider: /* @__PURE__ */ t(so, {
    borderColor: "gray.200"
  }),
  children: e.map((r) => {
    var n;
    return /* @__PURE__ */ t(vp, {
      onRemoveFile: o,
      ...r
    }, (n = r.key) != null ? n : r.file.name);
  })
}), Tu = ({
  onAddFiles: e,
  onRemoveFile: o,
  allowMultiple: r = !1,
  acceptedFileTypes: n,
  maxFileSize: a,
  name: i,
  id: l = i,
  error: s,
  label: c,
  formHelperText: p,
  isRequired: d,
  controlStyleProps: u,
  controlClassName: h,
  hideOptionalLabel: g = !1,
  files: f = [],
  fileTypesList: m = [],
  ...y
}) => {
  const x = y["data-testid"], {
    getInputProps: _,
    getRootProps: w,
    isDragActive: k
  } = ji({
    accept: n,
    multiple: r,
    maxSize: a,
    onDropAccepted: (T) => {
      e(T.map((F) => ({
        file: F,
        progressPercentage: 0
      })));
    },
    onDropRejected: (T) => {
      e(T.map((F) => ({
        file: F.file,
        progressPercentage: 0,
        error: F.errors.map((be) => be.message).join(". ")
      })));
    }
  });
  return /* @__PURE__ */ b(J, {
    spacing: 4,
    children: [/* @__PURE__ */ t(V, {
      name: i,
      hideOptionalLabel: g,
      id: l,
      error: s,
      label: c,
      isRequired: d,
      formHelperText: p,
      "data-testid": x && `${x}-control`,
      className: h,
      ...u,
      children: /* @__PURE__ */ b(xe, {
        ...y,
        width: "100%",
        height: "324px",
        backgroundColor: k ? "gray.200" : "gray.50",
        ...w(),
        borderWidth: "1px",
        borderStyle: "dashed",
        p: 10,
        borderRadius: "lg",
        borderColor: "gray.200",
        ...s && {
          borderColor: "red.500",
          borderStyle: "solid",
          boxShadow: `0 0 0 1px ${go.red[500]}`
        },
        children: [/* @__PURE__ */ t("input", {
          ..._()
        }), /* @__PURE__ */ b(J, {
          spacing: 4,
          textAlign: "center",
          children: [/* @__PURE__ */ t(xe, {
            children: /* @__PURE__ */ t(Od, {
              variant: "light",
              size: "4xl"
            })
          }), /* @__PURE__ */ t($, {
            variant: "body",
            children: "Drag and drop files here"
          }), /* @__PURE__ */ t($, {
            variant: "body",
            children: "OR"
          }), /* @__PURE__ */ t(xe, {
            children: /* @__PURE__ */ t(Y, {
              mb: 1,
              variant: "tertiary",
              children: "Browse"
            })
          }), /* @__PURE__ */ b(J, {
            spacing: 0,
            children: [m.length > 0 && /* @__PURE__ */ b($, {
              variant: "bodySmall",
              type: "secondary",
              children: ["File format: ", m.join(" / ")]
            }), a && /* @__PURE__ */ b($, {
              variant: "bodySmall",
              type: "secondary",
              children: ["Maximum size: ", Wo(a)]
            })]
          })]
        })]
      })
    }), f.length > 0 && /* @__PURE__ */ t(Cp, {
      onRemoveFile: o,
      files: f
    })]
  });
};
export {
  y0 as Accordion,
  _e as Alert,
  ku as AlertDialog,
  J0 as Avatar,
  kt as Badge,
  L0 as BooleanCheckbox,
  xu as Breadcrumb,
  Y as Button,
  Jd as ButtonGroup,
  N0 as CCCvcInput,
  P0 as CCExpiryInput,
  T0 as CCNumberInput,
  A0 as CCType,
  ou as Card,
  H0 as Checkbox,
  F0 as CheckboxGroup,
  zo as CheckboxGroupContext,
  Qd as ColumnToggle,
  R0 as CurrencyInput,
  $o as DateInput,
  _0 as DatePicker,
  I0 as DualInput,
  cu as ErrorAlert,
  So as ErrorMessage,
  I as FAIcon,
  Tu as FileUpload,
  zu as Footer,
  V as FormControl,
  op as GlobalHeader,
  bp as GlobalNav,
  gp as GlobalNavCategory,
  mp as GlobalNavMenu,
  fp as GlobalNavMenuItem,
  yp as GlobalNavSubMenu,
  xp as GlobalNavSubMenuItem,
  Su as Header,
  O as IconButton,
  iu as InfoAlert,
  Ee as Input,
  oe as Link,
  du as LoadingIndicator,
  wd as Logo,
  Po as Menu,
  Ro as MenuButton,
  yu as MenuDivider,
  fu as MenuGroup,
  Ao as MenuItem,
  To as MenuList,
  $u as Modal,
  G0 as NumberInput,
  vu as PageHeader,
  U0 as PasswordInput,
  E0 as PhoneInput,
  Iu as Popover,
  ko as Progress,
  X0 as Radio,
  Y0 as RadioGroup,
  Bo as RadioGroupContext,
  Oe as ResponseError,
  uu as ResponseErrorBadGateway,
  pu as ResponseErrorInternalServer,
  bu as ResponseErrorNotFound,
  hu as ResponseErrorUnauthorized,
  Mt as SearchInput,
  ke as Select,
  Mu as SideBar,
  Du as SideBarCategory,
  Bu as SideBarMenu,
  Nu as SideBarMenuItem,
  Pu as SideBarSubMenu,
  Au as SideBarSubMenuItem,
  Kd as Skeleton,
  mu as Slider,
  Cu as StepDetails,
  wu as Steps,
  su as SuccessAlert,
  It as Switch,
  ru as Table,
  n0 as TableContainer,
  e0 as TableEmptyState,
  c0 as TableHeader,
  g0 as TablePagination,
  au as Tabs,
  nu as Tag,
  m0 as Tbody,
  Ne as Td,
  K0 as TextArea,
  Co as Th,
  f0 as Thead,
  Jp as ThemeProvider,
  B0 as TimeInput,
  _u as Tooltip,
  ye as Tr,
  $ as Typography,
  lu as WarningAlert,
  wo as tableIdPrefix,
  tu as theme,
  gu as useToast
};
